<template>
    <div>
        <div v-if="!editRegistration" class="row mb-3">
            <div class="col-12">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ name: 'website' }">Event Details</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ name: 'website-types' }">Select Registration Type</el-breadcrumb-item>
                    <el-breadcrumb-item>
                        Register
                        <span v-if="registrations.length">
                            {{ registrations[0].type.name }}
                        </span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>

        <!-- show breadcrumbs for admin edit -->
        <div v-if="adminEdit && registrations && registrations.length" class="mb-2">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ name: 'attendees' }">Attendees</el-breadcrumb-item>
                <el-breadcrumb-item v-if="updatingType" :to="{ name: 'attendee', params: { registrationId: oldPrimaryRegForTypeChange._id } }">{{ oldPrimaryRegForTypeChange.confirmationNumber }}</el-breadcrumb-item>
                <el-breadcrumb-item v-else :to="{ name: 'attendee', params: { registrationId: registrations[0]._id } }">{{ registrations[0].confirmationNumber }}</el-breadcrumb-item>
                <el-breadcrumb-item>Edit</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

       <div class="form-container">
            <card  class="custom-card-box left-form" style="position: relative;">
                <div v-if="loading" style="position: absolute; z-index:100;  top: 0; left:0; width: 100%; height: 100%; color:rgb(0, 0, 0); background: rgba(252, 252, 252, 0.7); pointer-events: none;">
                    <div style="position: sticky; top: 0; display:flex; align-items: center; justify-content: center; height:100vh;">
                        <Loading style="font-weight: bold;" />
                    </div>
                </div>
                <template slot="header">
                    <div class="reg-card-header">
                        <span v-if="editRegistration">Edit Registration</span>
                        <span v-else>Register</span>
                    </div>
                </template>
                <router-link v-if="editRegistration && !$route.params.code" :to="{path: '/welcome-email/'+primaryRegistrationID }" class="btn custom-btn">View Status/ Confirmation</router-link>
                <router-link v-if="editRegistration && !$route.params.code"
                    :to="{ name: 'attendees', query: { parent: primaryRegistrationID } }">
                        <el-button class="btn">
                            <fa icon="users"/> See group
                        </el-button>
                </router-link>
                <router-link v-if="editRegistration && !$route.params.code"
                    :to="{ name: 'attendee',params: { registrationId: primaryRegistrationID, }, query: { tab: 'payments' } }">
                        <el-button class="btn">
                            <span class="fa fa-money mr-2"></span> Payments
                        </el-button>
                </router-link>
                <div class="row">
                    <div class="col-12 mt-5">
                        <el-form
                            :label-position="$store.state.props.isMobile ? 'top' : 'right'"
                            class="mb-5 main-form-container"
                        >
                            <el-form-item>
                                <div class="profile-image-viewer">
                                    <figure class="avatar-img form-avtar-image">
                                        <img
                                        v-if="event && event.logo && event.logo.path"
                                        :src="baseUrl + event.logo.path"
                                        >
                                    </figure>
                                    <h3 class="m-0 ml-3 profile-name">{{ event.name }}</h3>
                                </div>
                            </el-form-item>
                            <div class="row">
                                <div class="col-sm-6 col-lg-4 form-field-format">
                                    <el-form-item class="" v-if="user && user._id" label="Registration as of date">
                                        <el-date-picker v-model="asofdate" type="datetime"/>
                                    </el-form-item>
                                </div>

                                <div class="col-sm-6 col-lg-4 form-field-format">
                                    <el-form-item v-if="user && user._id" label="Registation Date">
                                        <el-date-picker v-model="primaryRegDate" type="datetime" disabled/>
                                    </el-form-item>
                                </div>
                            </div>
                            <div v-if="adminEdit && (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].changeRegistrationTypeForRegistrant))" class="row">
                                <div class="col-12">
                                    <el-form-item class="" v-if="user && user._id" :disabled="loading" label="Registration Type">
                                        <el-select
                                            :disabled="loading"
                                            @change="handleTypeInputChange"
                                            style="width: 100%;"
                                            class="disabled-select"
                                            v-model="registrationTypeId"
                                        >
                                            <el-option
                                                v-for="t in Object.values(getValidTypesForRegistrant)"
                                                :value="t._id"
                                                :label="t.name"
                                            />
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-form>
                        <el-form class="main-form-container"
                            v-for="(registration, regIndex) in registrations"
                            :key="`registration-${regIndex}`"
                            :label-position="$store.state.props.isMobile ? 'top' : 'right'">
                                <div v-if="registration.type && registration.type._id && registration.type.fields && registration.type.fields.length">
                                    <!-- <div v-if="registration.error" class="bg-danger p-3 text-center" style="color:white">
                                        Invalid Secondary Registrant
                                    </div> -->
                                    <el-form-item label="" style="background-color: #25a5f5 !important; color: #fff !important; text-align:center !important; padding-top: 5px !important;">
                                        <h6 v-if="regIndex === 0" class="clearfix">Primary Registrant ({{registration.type.name}})</h6>
                                        <!-- <h6 v-else-if="adminAdd || user.admin" class="divider"> -->
                                        <h6 v-else class="clearfix">
                                        <span class=""> REGISTRANT #{{ regIndex + 1 }} ({{registration.type.name}})</span>
                                            <el-button v-if="!registration._id && !updatingType"
                                                @click="removeRegistration(registration, regIndex)"
                                                type="text"
                                                class="close-btn ml-2 float-right"><i class="fa fa-times" aria-hidden="true"></i></el-button>
                                            <el-button v-if="registration._id && registrantEdit && event.allowRegistrantToDeleteRegistrant"
                                                @click="deleteRegistrantBySelf(registration, regIndex)"
                                                type="text"
                                                class="close-btn ml-2 float-right">
                                                    <i class="fa fa-times" aria-hidden="true"></i>
                                            </el-button>
                                        </h6>
                                    </el-form-item>
                                    <el-form-item
                                        v-for="(field, index) in registration.fields"
                                        v-if="field && field.published && field.showField && ((adminAdd || adminEdit) || field.showOnRegistrationScreen)"
                                        :key="`custom-field-${index}`"
                                        :label="`${field.title} ${field.required ? '*': ''}`">
                                        <div class="clearfix"></div>
                                        <p v-if="field.description" class="d-block mb-1">{{ field.description }}</p>
                                        
                                            <el-date-picker
                                                v-if="field.type === 'calendar'"
                                                v-model="field.value"
                                                :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )"/>
                                            <div v-if="field.type === 'media'" class="d-flex" style="justify-content: space-between;">
                                                <div class="d-flex flex-column">
                                                    <div
                                                        style="max-width:max-content;"
                                                        v-if="field && field.published && field.showField && ((adminAdd || adminEdit) || field.showOnRegistrationScreen)"
                                                        class="form-group">
                                                            <input
                                                                :ref="`field-${field._id}`"
                                                                type="file"
                                                                :id="`file-upload-${field._id}`"
                                                                @change="handleMediaChange($event, field); handleChange(field, regIndex)">
                                                            <label :for="`file-upload-${field._id}`">
                                                                <el-button>Choose File</el-button>
                                                            </label>
                                                    </div>
                                                    <a
                                                        style="max-width:max-content;"
                                                        v-if="getMedia && getMedia[field._id]"
                                                        :href="getMedia[field._id].url"
                                                        :download="getMedia[field._id].url"
                                                        @click.prevent="download({ path: getMedia[field._id].path, name: getMedia[field._id].name  })">
                                                            {{ getMedia[field._id].name }}
                                                    </a>
                                                    <p v-if="field.value">{{ field.value.name }}</p>
                                                    <div v-if="uploadingFiles[field._id] && uploadingFiles[field._id].bannerProgress !== 100">
                                                        <el-progress :percentage="uploadingFiles[field._id].bannerProgress"/>
                                                    </div>
                                                    <div
                                                        v-else-if="field.value && field.value._id"
                                                        class="form-text">
                                                            <a
                                                                :href="baseUrl + field.value.path"
                                                                :download="field.value.name"
                                                                @click.prevent="download(field.value)">
                                                                    {{ field.value.name }}
                                                            </a>
                                                    </div>
                                                </div>
                                                <div @click.prevent="removeFile(field)" v-if="(getMedia && getMedia[field._id]) || field.value">
                                                    <button class="btn">Delete</button>
                                                </div>
                                            </div>
                                            <div v-else-if="field.type === 'checkboxes'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-checkbox-group class="align-item-checkbox"
                                                    v-model="field.value"
                                                    @change="onCheckboxChange(registration, index, field, $event); handleChange(field, regIndex);"
                                                    :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )">
                                                        <el-checkbox
                                                            v-for="(value, index) in field.values.split('\n')"
                                                            :checked="false"
                                                            :label="value">
                                                                {{ field.labels.split('\n')[index] }}
                                                        </el-checkbox>
                                                </el-checkbox-group>
                                            </div>
                                            <div v-else-if="field.type === 'list'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-select
                                                    v-model="field.value"
                                                    @change="onListChange(registration, field, $event); handleChange(field, regIndex);"
                                                    :disabled="(!hasSpecialPrivilege && field.specialPrivilegeNeededToEdit) || (!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false ))">
                                                        <el-option
                                                            v-for="(value, index) in field.values.split('\n')"
                                                            :value="value"
                                                            :label="field.labels.split('\n')[index]"/>
                                                </el-select>
                                            </div>
                                            <!-- <div v-else-if="registration.type.fields[index].type === 'list'">
                                                <el-select
                                                    v-model="field.value"
                                                    @change="onListChange(registration, field, $event)"
                                                    :disabled="!(adminAdd || adminEdit) && (!field.registrantEditable || (editRegistration && !field.registrantEditableDuringEditRegistration))">
                                                        <el-option
                                                            v-for="(value, index) in field.values.split('\n')"
                                                            :value="value"
                                                            :label="field.labels.split('\n')[index]"/>
                                                </el-select>
                                            </div> -->
                                            <div v-else-if="field.type === 'radio'" class="align-radio-btn">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-radio
                                                    v-for="(value, index) in field.values.split('\n')"
                                                    v-model="field.value"
                                                    :label="value"
                                                    @change="onRadioChange(registration, index, field, $event); handleChange(field, regIndex);"
                                                    :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )">
                                                        {{ field.labels.split('\n')[index] }}
                                                </el-radio>
                                            </div>
                                            <div v-else-if="field.type === 'color'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-color-picker
                                                    @change="handleChange(field, regIndex);"
                                                    v-model="field.value"
                                                    :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )"
                                                />
                                            </div>
                                            <div v-else-if="field.type === 'integer'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-input
                                                    @change="handleChange(field, regIndex);"
                                                    v-model="field.value"
                                                    type="number"
                                                    :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )"
                                                />
                                            </div>
                                            <div v-else-if="field.type === 'text'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-input
                                                    v-model="field.value"
                                                    @change="handleChange(field, regIndex);"
                                                    :disabled="(!hasSpecialPrivilege && field.specialPrivilegeNeededToEdit) || (!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false ))">
                                                        <template
                                                            v-if="field.validations.url"
                                                            slot="prepend">https://</template>
                                                        <template
                                                            v-if="field.validations.ip"
                                                            slot="prepend">IP</template>
                                                </el-input>
                                            </div>

                                            <div v-else-if="field.type === 'textarea'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <el-input
                                                    v-model="field.value"
                                                    @change="handleChange(field, regIndex);"
                                                    type="textarea"
                                                    :disabled="(!hasSpecialPrivilege && field.specialPrivilegeNeededToEdit) || (!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false ))"/>
                                            </div>
                                            <div v-else-if="field.type === 'editor'">
                                                <p :ref="`field-${regIndex}-${field._id}`" class="err-msg"></p>
                                                <quill-editor
                                                    v-model="field.value"
                                                    @change="handleChange(field, regIndex);"
                                                    :disabled="!(adminAdd || adminEdit) && ( registration._id ? (!field.registrantEditable || (editRegistration && (field.registrantEditableDuringRegistration==undefined ? !field.registrantEditableDuringEditRegistration : !field.registrantEditableDuringRegistration ))) : field.registrantEditableDuringRegistrationNewRegistrant==false )"/>
                                                <!-- <p v-if="field.description" class="mt-3">{{ field.description }}</p> -->
                                            </div>
                                    </el-form-item>
                                    <el-form-item>
                                        <el-checkbox-group
                                            v-model="registration.registeredActivities"
                                            @change="calculateTotal(registration)"
                                            class="mt-2">
                                                <el-checkbox
                                                    v-for="activity in activities"
                                                    v-if="!(activity.dependsOnFields && activity.dependsOnFields.length)"
                                                    :label="activity"
                                                    class="d-flex align-items-center m-0 mb-1">
                                                        {{ activity.name }}
                                                </el-checkbox><br>
                                        </el-checkbox-group>
                                    </el-form-item>
                                    <el-form-item v-if="registration.type && registration.type._id && user._id" label="">
                                        <h6>Charges Summary</h6>
                                        <!-- <div class="d-flex justify-content-between">
                                            <span>Registration Price Before Discount </span>
                                            <span >${{ registration.type.price }}</span>
                                        </div> -->

                                        <!-- <div v-if="registration.discount.value>0" class="d-flex justify-content-between">
                                            <span>Registration Price After Discount </span>
                                            <span v-if="registration.discount.type=='percent'">${{ registration.type.price - ((registration.type.price/100)* registration.discount.value) }}</span>
                                            <span v-else>${{ registration.type.price - registration.discount.value }}</span>
                                        </div> -->
                                        
                                        <div class="d-flex justify-content-between">
                                            <h6>Registration Fee </h6>
                                            <span class="highlight-fee">
                                                <span class="activity-fee" v-if="registration._discountAmount>0">${{ registration.type.price }}</span>
                                                ${{ registration.type.price - registration._discountAmount }}
                                            </span>
                                            <!-- <h6 >USD {{ registration.type.price - registration._discountAmount }}</h6> -->
                                        </div>

                                        <!-- registration.totals[field._id] -->
                                        <div
                                            v-for="field in registration.fields"
                                            v-if="registration.totals[field._id]"
                                            :key="`fee-field-charge-${field._id}`">
                                                <div class="d-flex justify-content-between">
                                                    <span>{{ field.title }}</span>
                                                    <span class="highlight-fee">
                                                        <span class="activity-fee" v-if="field._discountAmount>0">${{registration.totals[field._id] }}</span>
                                                        ${{ (registration.totals[field._id] - field._discountAmount) }}
                                                    </span>
                                                </div>
                                        </div>
                                        <div v-if="registration.registeredActivities.length">
                                            <p class="font-weight-bold mt-3">Attending Activities</p>
                                            <div
                                                v-for="activity in registration.registeredActivities"
                                                class="d-flex justify-content-between">
                                                    <span>{{ activity.name }}</span>
                                                    <span :class="{'highlight-fee': (activity._discountAmount > 0)}">
                                                    <span class="activity-fee" v-if="activity._discountAmount > 0">
                                                        USD {{ (activity.typeBasedFee && activity.typeBasedFee[registration.type._id]) || activity.fee }}
                                                    </span>
                                                    ${{ ((activity.typeBasedFee && activity.typeBasedFee[registration.type._id]) || activity.fee) - activity._discountAmount }}
                                                    </span>
                                            </div>
                                        </div>
                                        <div v-if="registration.fieldBasedActivities.length">
                                            <p class="font-weight-bold mt-3">Included Activities</p>
                                            <div
                                                v-for="activity in registration.fieldBasedActivities"
                                                class="d-flex justify-content-between">
                                                    <span>{{ activity.name }}</span>
                                                    <!-- <span :class="{'highlight-fee': (activity.discountPrice > 0)}"><span class="activity-fee" v-if="activity.discountPrice > 0">${{activity.activityFee}}</span>${{ (activity.typeBasedFee && (activity.typeBasedFee[registration.type._id] - activity.discountPrice) ) || activity.typeBasedFee[registration.type._id] }}</span> -->

                                                    <span :class="{'highlight-fee': (activity._discountAmount > 0)}">
                                                    <span class="activity-fee" v-if="activity._discountAmount > 0">
                                                        USD {{ (activity.typeBasedFee && activity.typeBasedFee[registration.type._id]) || activity.fee }}
                                                    </span>
                                                    USD {{ ((activity.typeBasedFee && activity.typeBasedFee[registration.type._id]) || activity.fee) - activity._discountAmount }}
                                                    </span>

                                                    <!-- <span :class="{'highlight-fee': (activity._formatedDiscount.discountPrice > 0)}">
                                                    <span class="activity-fee" v-if="activity._formatedDiscount.discountPrice > 0">
                                                        ${{ activity._formatedDiscount.activityFee }}
                                                    </span>
                                                    ${{activity._formatedDiscount.discountFee }}
                                                    </span> -->
                                            </div>
                                        </div>
                                        <!-- <div class="d-flex justify-content-between">
                                            <span class="font-weight-bold">Total</span>
                                            <span class="font-weight-bold">
                                                ${{ registration.total }}
                                            </span>
                                        </div> -->
                                    </el-form-item>
                                </div>
                        </el-form>
                        <div class="row">
                            <div
                                v-for="type in registrationType.groups "
                                v-if="(!registrationType.hiddenFromExternal.includes(type._id) && registrationType.groupCount && registrationType.groupCount[type._id] && registrationType.groupCount[type._id] > 0)"
                                class="col-12 d-flex justify-content-end">
                                    <div class="textWithBtn">
                                        <p>
                                            <b>+ </b> Add new <b>{{ type.name }}</b> registration ({{ registrationType.groupCount[type._id] }} left)
                                        
                                        <el-button
                                        @click="addRegistration(type)"
                                        type="link" class="btn custom-btn">Click here</el-button>
                                        </p>
                                    </div>

                                    <!-- <el-button
                                        @click="addRegistration(type)"
                                        type="link" class="btn btn-primary">
                                            Add new {{ type.name }} registration ({{ registrationType.groupCount[type._id] }} left)
                                    </el-button> -->
                            </div>
                        </div>
                    </div>
                </div>
                <template slot="footer">
                    <div id="payment-footer">
                        <div v-if="adminEdit" class="d-flex justify-content-between mb-3" style="display:none !important;">
                            <span class="font-weight-bold">Recalculate Fees</span>
                            <span class="font-weight-bold">
                                <el-checkbox v-model="recalculateFees"/>
                            </span>
                        </div>
                        <div v-if="adminEdit" class="d-flex justify-content-between mb-3" style="display:none !important;">
                            <span class="font-weight-bold">Auto Adjust Activities</span>
                            <span class="font-weight-bold">
                                <el-checkbox v-model="autoAdjustActivities" disabled/>
                            </span>
                        </div>
                        <!-- <div class="d-flex justify-content-between">
                            <span class="font-weight-bold">Gross Amount</span>
                            <span class="font-weight-bold">
                                ${{ payment.total }}
                            </span>
                        </div> -->
                        <div class="d-flex justify-content-between" v-if="editRegistration && needTosave" >
                            <span class="font-weight-bold"></span>
                            <span class="font-weight-bold" style="color:red;">unapplied changes - Please click on Save for this changes to be applied</span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="user._id || !event.hideAllPaymentInfoFromRegistrant">
                            <span class="font-weight-bold">Price Before Discount</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(payment.priceBeforeDiscount).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="editRegistration && manaualDiscoutns">
                            <span class="font-weight-bold text-underline">Additional Discounts</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(manaualDiscoutns).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="editRegistration && manaualCharges">
                            <span class="font-weight-bold text-underline">Additional Charges</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(manaualCharges).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="user._id || !event.hideAllPaymentInfoFromRegistrant">
                            <span class="font-weight-bold">Net Total</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(payment.priceAfterDiscount).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between">
                            <span class="font-weight-bold">&nbsp;</span>
                            <span class="font-weight-bold"> &nbsp;                           
                            </span>
                        </div>
                        <div v-if="(editRegistration && registrations[0]) &&  (user._id || !event.hideAllPaymentInfoFromRegistrant)">
                            <div class="d-flex justify-content-between">
                                <span class="font-weight-bold">Amount Paid</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(registrations[0].paid).toFixed(2) }}
                                </span>
                            </div>
                            <div v-if="(user._id || !event.hideAllPaymentInfoFromRegistrant)" class="d-flex justify-content-between">
                                <span class="font-weight-bold">Amount Due</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(payment.priceAfterDiscount - registrations[0].paid).toFixed(2) }}
                                    <!-- ${{ payment.total - registrations[0].paid }} -->
                                    <!-- ${{ totalpriceAfterDiscount - registrations[0].paid }} -->
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="payment.paymentType === 'deposit'"
                            class="d-flex justify-content-between">
                                <span class="font-weight-bold">Deposit Amount</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(payment.depositAmount).toFixed() }}
                                </span>
                        </div>
                        <!-- <div class="d-flex justify-content-between align-items-center">
                            <span class="font-weight-bold">Payment Type</span>
                            <span class="font-weight-bold">
                                <el-select v-model="payment.paymentType">
                                    <el-option label="Full Payment" value="full"/>
                                    <el-option v-if="event.allowDeposit" label="Deposit" value="deposit"/>
                                </el-select>
                            </span>
                        </div> -->
                        <!-- <div class="d-flex justify-content-between align-items-center flex-wrap">
                            <span class="font-weight-bold">Payment Method</span>
                            <span class="font-weight-bold">
                                <el-select v-model="payment.paymentMethod">
                                        <el-option v-if="event.allowCash" label="Check Payment" value="check"/>
                                        <el-option label="Online Payment" value="online"/>
                                </el-select>
                            </span>
                            <p v-if="payment.paymentMethod === 'online'" class="w-100 text-right font-italic font-weight-bold" style="font-size: 12px;">
                                For online payments {{ event.onlinePaymentProcessingFee }}% fee is calculated
                            </p>
                        </div> -->
                        <div class="d-flex justify-content-end">
                            <el-checkbox v-model="agreed">
                                I accept <a href="#" @click.prevent="$store.commit('SHOW_DIALOG', 'termsAndConditions')">Terms and Conditions</a>
                            </el-checkbox>
                        </div>
                        <!-- <div class="d-flex justify-content-end mt-2">
                            <recaptcha
                                :sitekey="recaptcha"
                                @verify="onRecaptchaVerify"
                                ref="recaptcha"/>
                        </div> --> 
                    </div>
                    <!--  && !editRegistration -->
                    <div class="d-flex justify-content-between mt-2" v-if="!this.adminEdit && event.allowDeposit && event.onlinePaymentOnly && event.depositAmount<payment.priceAfterDiscount">
                        <span class="font-weight-bold">Select Payment Amount</span>
                        <span class="font-weight-bold input-payment-amount-select-group">
                            <el-radio v-model="paymentAmountChose" label="minimum">Minimum (USD {{minimum_amount_to_pay}})</el-radio>
                            <el-radio v-model="paymentAmountChose" label="fullAmount"><span>Amount Due (USD {{ registrations.length && registrations[0].paid ? payment.priceAfterDiscount - registrations[0].paid : payment.priceAfterDiscount}})</span></el-radio>
                            <el-radio v-model="paymentAmountChose" label="custom">Custom</el-radio>
                            <el-input v-if="paymentAmountChose=='custom'" v-model="custom_payment_amt" class="col-3" type="number" :min="minimum_amount_to_pay">Custom</el-input>
                        </span>
                    </div>
                    <div class="d-flex justify-content-end mt-3">
                        <router-link :to="{ name: 'website' }">
                            <el-button type="primary" class="btn mr-2">
                                Cancel
                            </el-button>
                        </router-link>
                        <el-button :disabled="adminEdit && !userIsAllowedToEdit" v-if="(user._id && (user.admin || (event.adminRoles && event.adminRoles[user._id] && event.adminRoles[user._id].checkinRegistrants))) || !user._id"
                            type="primary"
                            class="btn btn-primary"
                            @click="submit()"
                            :loading="saving">
                                <span v-if="editRegistration">Save</span>
                                <span v-else-if="payment.paymentMethod === 'online'">Proceed To Payment</span>
                                <span v-else>Register</span>
                        </el-button>
                    </div>
                </template>
            </card>
            <div class="right-amount" style="z-index: 200;">
                <div class="amount-card-inner">
                    <div>
                        <div v-if="editRegistration">
                            <p class="m-0 p-0">
                                <strong>Total Registrants : {{ registrations.length }}</strong>
                            </p>
                        </div>
                        <p v-if="adminAdd || adminEdit">
                            <strong>Min Registrants : {{ registrationType.minimumCount ? registrationType.minimumCount : 'NA' }}</strong>
                        </p>
                        <div v-if="adminEdit" class="d-flex justify-content-between mb-3 mt-2" style="display:none !important;">
                            <span class="font-weight-bold">Recalculate Fees</span>
                            <span class="font-weight-bold">
                                <el-checkbox v-model="recalculateFees"/>
                            </span>
                        </div>
                        <div v-if="adminEdit" class="d-flex justify-content-between mb-3" style="display:none !important;">
                            <span class="font-weight-bold">Auto Adjust Activities</span>
                            <span class="font-weight-bold">
                                <el-checkbox v-model="autoAdjustActivities" disabled/>
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="editRegistration && needTosave" >
                            <span class="font-weight-bold"></span>
                            <span class="font-weight-bold" style="color:red;">unapplied changes - Please click on Save for this changes to be applied</span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="user._id || !event.hideAllPaymentInfoFromRegistrant">
                            <span class="font-weight-bold">Price Before Discount</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(payment.priceBeforeDiscount).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="editRegistration && manaualDiscoutns">
                            <span class="font-weight-bold text-underline">Additional Discounts</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(manaualDiscoutns).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="editRegistration && manaualCharges">
                            <span class="font-weight-bold text-underline">Additional Charges</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(manaualCharges).toFixed(2) }}
                            </span>
                        </div>
                        <div class="d-flex justify-content-between" v-if="user._id || !event.hideAllPaymentInfoFromRegistrant">
                            <span class="font-weight-bold">Net Total</span>
                            <span class="font-weight-bold">
                                USD {{ parseFloat(payment.priceAfterDiscount).toFixed(2) }}
                            </span>
                        </div>
                        <div v-if="adminEdit" class="d-flex justify-content-between">
                            <span class="font-weight-bold">&nbsp;</span>
                            <span class="font-weight-bold"> &nbsp;                           
                            </span>
                        </div>
                        <div v-if="(editRegistration && registrations[0]) &&  (user._id || !event.hideAllPaymentInfoFromRegistrant)">
                            <div class="d-flex justify-content-between">
                                <span class="font-weight-bold">Amount Paid</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(registrations[0].paid).toFixed(2) }}
                                </span>
                            </div>
                            <div v-if="(user._id || !event.hideAllPaymentInfoFromRegistrant)" class="d-flex justify-content-between">
                                <span class="font-weight-bold">Amount Due</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(payment.priceAfterDiscount - registrations[0].paid).toFixed(2) }}
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="payment.paymentType === 'deposit'"
                            class="d-flex justify-content-between">
                                <span class="font-weight-bold">Deposit Amount</span>
                                <span class="font-weight-bold">
                                    USD {{ parseFloat(payment.depositAmount).toFixed() }}
                                </span>
                        </div>
                        <a href="#payment-footer" class="go-to-payment-btn btn btn-primary">Scroll down to Submit Registration</a>
                    </div>
                </div>
            </div>
       </div>

       <el-dialog
            title="Message"
            :visible.sync="formVisibleSync">
                Sorry, Registration has been closed for {{event.name}}
        </el-dialog>
       <el-dialog
            title="Error"
            :visible.sync="showTypeChangeErrors">
            <div v-if="typeChangeErrors.fields.length">
                The following fields couldn't be mapped properly -
                <ul>
                    <li v-for="(f,i) in typeChangeErrors.fields" :key="i">
                        {{ f.field.name }} of {{ f.index == 0 ? 'primary registrant' : `registrant ${ f.index + 1 }`}} 
                    </li>
                </ul>
            </div>
            <div v-if="typeChangeErrors.registrants.length">
                The last {{ typeChangeErrors.registrants.length }} registrant(s) couldn't be mapped properly
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import http from '../../http'
import download from 'downloadjs'
import Loading from '../Loading.vue';

export default {
    components:{Loading},
    data () {
        return {
            applicableActivitesDiscount: [],
            email: '',
            registrations: [],
            saving: false,
            agreed: false,
            registrationType: {},
            gettingRegistration: false,
            uploadingFiles: {},
            editRegistration: false,
            adminAdd: false,
            adminEdit: false,
            registrantEdit: false,
            recalculateFees: true,
            autoAdjustActivities: true,
            previousTotal: {},
            payment: {
                // paymentType: null,
                paymentType: "full",
                // paymentMethod: null,
                paymentMethod: "check",
                total: 0,
                priceBeforeDiscount: 0,
                priceAfterDiscount: 0,
                depositAmount: 0,
                grecaptcha: ''
            },
            registrationPriceDetails: [],
            discount:{},
            totalpriceBeforeDiscount: 0,
            totalpriceAfterDiscount: 0,
            asofdate: null,
            primaryRegDate: null,
            needTosave: false,
            manaualDiscoutns: 0,
            manaualCharges: 0,
            removedList : [],
            paymentAmountChose: null,
            payment_amount: 0,
            custom_payment_amt: 0,
            minimum_amount_to_pay: 0,
            primaryRegistrationID: null,
            websiteNewRegistrationForm: false,
            formVisibleSync: false,
            totalDuplicateFields: null,
            editMode:false,
            uploadedFiles: [],
            registationId: null,
            uploaded: null,
            fieldsWithSorting: {},
            enhancedValidations: [],
            validationResults: {},
            activeErrorFields: [],
            activeErrorFieldMessages: [],
            initialValidationRun: false,
            oldValuesWhileEdit:[],
            registrationTypeId: '',
            updatingType: false,
            oldPrimaryRegForTypeChange: null,
            invalidSecondaryRegError: false,
            typeChangeErrors:{
                fields: [],
                registrants: []
            },
            showTypeChangeErrors: false,
            loading: false
        }
    },
    computed: {
        ...mapState([
            'types',
            'recaptcha',
            'event',
            'activities',
            'baseUrl',
            'user',
        ]),
        getValidTypesForRegistrant(){
            let types = {};
            this.types 
            ?   this.types.map(el => {
                    if(!el.typeGroupOnly){
                        return types[el._id] = el
                    }
                }) 
            :   null
            return types;
        },
        getValidTypesForSecondaryRegistrant(){
            let types = {};
            this.types 
            ?   this.types.map(el => {
                    if(el.typeGroupOnly){
                        return types[el._id] = el
                    }
                }) 
            :   null
            return types;
        },
        getMedia(){
            let arr = []
            this.uploadedFiles.forEach(el=>{
                arr[el.fieldId] = {
                    url: this.baseUrl + el.path,
                    name: el.name,
                    path: el.path
                }
            })
            return arr
        },
        hasSpecialPrivilege(){
            if(this.user._id && this.user.admin){
                return true
            }
            if(this.user._id && this.user.roles[this.$route.params.eventId].specialAdminPrivilegeForCertainFields){
                return true
            }
            return false
        },
        userIsAllowedToEdit(){
            if(this.user._id && this.user.admin){
                return true
            }
            if(!this.user._id){
                return true
            }
            if(this.registrations.length > 0){
                const { value, date } = this.user.roles[this.$route.params.eventId].preventUserFromEditingRegistrationsCreatedAfterDate;
                if(!value) return true;

                const createdAt = new Date(this.registrations[0].createdAt);
                const userAllowedToEditAfterDate = new Date(date);

                // console.log("createdAT: ", createdAt);
                // console.log("userAllowedToEditAfterDate: ", userAllowedToEditAfterDate);

                if(createdAt < userAllowedToEditAfterDate){
                    return false
                }
                return true
            }

            return true
        }
    },
    async mounted () {
        this.loading = true
        if(!this.user._id && this.event.preventExternalRegistrations){
            return this.$router.push(`/unavailable/${this.event._id}`)
        }
        this.payment.depositAmount = this.event.depositAmount;
        this.payment.paymentMethod = this.event.onlinePaymentOnly ? 'online' : this.payment.paymentMethod;
        this.custom_payment_amt = this.event.depositAmount;
        this.minimum_amount_to_pay = this.event.depositAmount;

        const res = await (await http.get(`/api/fields`, {params: {filters:{eventId:this.$route.params.eventId, sortUsingValuesWhileSaving: true }}} )).data.fields;
        res.forEach(el=>{
            this.fieldsWithSorting[el._id] = el.values.split("\n");
        })
        if(this.types.length == 0){
            await this.$store.dispatch('getAll', {
                path: 'types',
                params: {
                    filters: {
                        eventId: this.$route.params.eventId
                    }
                }
            })
        }
        setTimeout(()=>{
            if (this.$route.params.typeId) {
                this.registrationType = this.types.find(type => type._id === this.$route.params.typeId)
            }
            // creating new registration
             if (this.registrationType && this.registrationType._id && (this.$route.name !== 'website-registration-edit' &&
            this.$route.name !== 'registration-edit')) {
                if (this.user && this.user._id) {
                    this.adminAdd = true
                }else{
                    if(!this.registrationType.publicRegistration){
                        this.websiteNewRegistrationForm = true
                        this.formVisibleSync = true
                    }
                }
                this.addRegistration(this.registrationType)
            }
        }, 1000)

        // registration edit functionality
        if (this.$route.name === 'website-registration-edit' ||
            this.$route.name === 'registration-edit') {
                this.editRegistration = true
                this.autoAdjustActivities = false

                if (this.$route.name === 'registration-edit') {
                    this.adminEdit = true
                }

                await this.getRegistrant()
                this.editMode = true
        }
        await this.getFields();

        if (this.$route.params.typeId) {
            await this.fetchValidations(this.$route.params.eventId, this.$route.params.typeId)
        }
        this.loading = false
    },
    watch: {
      asofdate: {
        deep: true,
        handler: function() {
        //   this.payment.priceBeforeDiscount = 0
        //   this.payment.priceAfterDiscount = 0
          for(let registration of this.registrations){
            registration.asofdate = this.asofdate
            this.calculateTotal(registration)
          }
        }
      },
      registrations: {
        deep: true,
        handler: async function() {
            //console.log("@registrations: ", this.registrations)
            this.payment.priceBeforeDiscount = 0
            this.payment.priceAfterDiscount = 0
            let _priceBeforeDiscount = 0
            let _priceAfterDiscount = 0
            for(let _reg of this.registrations) {
                if(Object.keys(_reg).includes("priceDetails")) {
                    // Calcualting Registration Price
                    _priceBeforeDiscount += _reg.priceDetails.regPrice
                    _priceAfterDiscount += parseFloat(_reg.priceDetails.regPrice - _reg.priceDetails.regDiscountPrice)

                    // Registration Type Field Prices
                    for(let _field of _reg.priceDetails.regFieldDiscounts){
                        _priceBeforeDiscount += _field.totalFee
                        _priceAfterDiscount += parseFloat(_field.totalFee - _field.discount)
                    }

                    // Registration Activity Field Prices
                    for(let _field of _reg.priceDetails.regActivityDiscounts){
                        _priceBeforeDiscount += _field.totalFee
                        _priceAfterDiscount += parseFloat(_field.totalFee - _field.discount)
                    }

                    // Field Based Activity Prices
                    for(let _field of _reg.priceDetails.regFieldBasedActivityDiscounts){
                        _priceBeforeDiscount += _field.totalFee
                        _priceAfterDiscount += parseFloat(_field.totalFee - _field.discount)
                    }
                }
            }
            _priceAfterDiscount -= this.manaualDiscoutns;
            _priceAfterDiscount += this.manaualCharges;
            this.payment.priceBeforeDiscount = _priceBeforeDiscount
            this.payment.priceAfterDiscount = _priceAfterDiscount
        }
      },
    //   userIsAllowedToEdit(nv){
    //     if(nv == false){
    //         this.$router.push({ name: 'forbidden', query:{ back: true } })
    //     }
    //   }
    },
    methods: {
        validateSecondaryReg(){
            let valid = true;
            for(let i=this.registrations.length-1; i > 0; i--){
                const type = this.getTypeForSecondaryByCount(i);
                if(!type){
                    console.log("err", this.registrations[i]);
                    this.registrations[i].error = true
                    valid = false
                    this.invalidSecondaryRegError = true
                }
            }
            return valid
        },
        async handleTypeInputChange(){
            this.loading = true
            this.updatingType = true
            this.registrations = []
            this.typeChangeErrors.fields = []
            this.typeChangeErrors.registrants = []
            const res = await http.get(`/api/registrations/${this.$route.params.id}?withChildregistrations=true`)
            this.oldPrimaryRegForTypeChange = res.data.registration

            let t = this.getValidTypesForRegistrant[this.registrationTypeId]
            await this.addRegistration(t)
            // populate date for the main reg
            this.registrations[0].registrationIndex = 0;
            this.registrations[0].totals= {};
            this.registrations[0].paid= res.data.registration.paid;
            
            this.registrations[0].fields.forEach(f =>{
                const val = this.getFieldValueFromRegistration(f._id, res.data.registration)
                if(val == null){
                    this.typeChangeErrors.fields.push({ field: f, index: 0 })
                    this.showTypeChangeErrors = true
                    f.value = ''
                }
                f.value = val
            })

            let children = res.data.childRegistrations
            let count = 1;
            for(let i=0; i<children.length; i++){
                let type = this.getTypeForSecondaryByCount(count);
                if(!type){
                    this.typeChangeErrors.registrants.push(this.registrations[count])
                    this.showTypeChangeErrors = true
                    return;
                }
                await this.addRegistration(type);
                this.registrations[count].fields.forEach(f =>{
                    let val = this.getFieldValueFromRegistration(f._id, children[i])
                    if(val == null){
                        f.value = ''
                        if(val){
                            this.typeChangeErrors.fields.push({ field: f, index: count })
                            this.showTypeChangeErrors = true
                        }
                    }                    
                    else if(val == '' || this.isValidFieldValue(f, val)){
                        f.value = val;
                    }else{
                        f.value = ''
                        if(val){
                            this.typeChangeErrors.fields.push({ field: f, index: count })
                            this.showTypeChangeErrors = true
                        }
                    }
                })
                count++;
            }
            this.getRegistrationType()
            this.registrations.forEach(reg =>{
                this.addFieldBasedActivities(reg)
            })
            this.loading = false
        },
        getTypeForSecondaryByCount(count){
            let type = null
            let t = this.getValidTypesForRegistrant[this.registrationTypeId]
            
            let sortedKeys = Object.keys(t.orderGroup)
            let idsInGroup =  t.groups.map(el => el._id)
            sortedKeys = sortedKeys.filter(el => idsInGroup.includes(el))
            sortedKeys.sort((a,b) =>{
                let orderOfA = parseInt(t.orderGroup[a])
                let orderOfB = parseInt(t.orderGroup[b])
                return orderOfA - orderOfB;
            });

            for(let i=0; i< sortedKeys.length; i++){
                let typeId = sortedKeys[i];

                let allowedCount = Object.values(t.groupCount)
                    .slice(0, i+1)
                    .map(el => parseInt(el, 10))
                    .reduce((acc, curr) => acc+curr, 0);
                if(count <= allowedCount){
                    type = this.getValidTypesForSecondaryRegistrant[typeId]
                    break;
                }
            }
            return type
        },
        isValidFieldValue(field, inpVal){
            let isInvalid = false
            const values = field.values ? field.values.split('\n') : null;
            if(values){
                if(field.type == "checkboxes"){
                    inpVal.forEach(el =>{
                        if(!values.includes(el)) {
                            isInvalid = true
                        }
                    })
                }
                else if(!values.includes(inpVal)){
                    isInvalid = true
                }
            }
            return !isInvalid;
        },
        async setCheckoutPageAmount(data = { amount: null, registrationId: null }){
            try {
                await http.put('/api/registrations/checkout-page-amount', data)
            } catch (error) {
                console.log(error);
            }
        },
        async fetchValidations(eventId, typeId){
            this.enhancedValidations = await (await http(`/api/enhanced-validations/${eventId}/${typeId}?onlyActive=true`)).data.validations  
        },
        runEnhancedValidations(){
            this.oldValuesWhileEdit = []
            this.enhancedValidations.forEach(val=>{
                val.rules.forEach(r =>{
                    let value = this.getFieldValueFromRegistration(r.fid)
                    let field = { _id: r.fid, value  }
                    if(this.editMode) this.oldValuesWhileEdit.push(field)
                    this.handleChange(field, 0)
                })
            })            
        },
        getFieldValueFromRegistration(fieldId, reg = null){
            let registration = reg ? reg : this.registrations[0];
            if(fieldId){
                let regFields = registration.fields;
                let field = regFields.find(el => el._id == fieldId)
                if(field && field.value != undefined) return field.value;
            }
            return null
        },
        handleChange(field, regIndex){
            this.activeErrorFields.forEach(id =>{
                this.hideErrorMessage(id, regIndex)
            })
            this.activeErrorFields = []
            this.activeErrorFieldMessages = []
            
            if(regIndex == 0 && !this.adminAdd && !this.adminEdit){
                this.activeValids = []
                this.activeErrors = []
                this.isThereValidationErrors = []

                this.enhancedValidations.forEach(val=>{
                    if(!this.validationResults[val._id]){
                        this.validationResults[val._id] = {
                            complete: false,
                            valid: false,
                            errorMessage: val.message,
                            fieldsWithError: [],
                            requiredFields: [],
                            current: false,
                            results: [],
                            _id: val._id
                        }
                    }
    
                    val.rules.forEach(r =>{
                        if(r.fid == field._id){
                            this.validationResults[val._id][field._id] = {
                                fid: field._id,
                                value: field.value,
                                acceptedValues: r.value,
                                isValid: (() =>{
                                    const validValues = r.value.split("\n");
                                    let valid = true

                                    if(Array.isArray(field.value)){
                                        if(field.value.length == 0){
                                            return false
                                        }
                                        
                                        field.value.forEach(v =>{
                                            if(!validValues.includes(v)){
                                                valid = false
                                            }
                                        })
                                    }else{
                                        valid = validValues.includes(field.value)
                                    }

                                    if(this.editMode){
                                        let oldValue = this.oldValuesWhileEdit.find(el => el._id == field._id).value
                                        let innerValid = false

                                        if(Array.isArray(oldValue)){
                                            
                                            field.value.forEach(v =>{
                                                if(oldValue.includes(v) && !validValues.includes(v)){
                                                    innerValid = true
                                                }
                                            })

                                        }else{
                                            innerValid = oldValue == field.value
                                        }

                                        if(innerValid) valid = false
                                    }


                                    return valid
                                })(),
                            }

                        }
                        if(!this.validationResults[val._id].requiredFields.includes(r.fid)){
                            this.validationResults[val._id].requiredFields.push(r.fid)
                        }
                    })
    
                    this.validationResults[val._id]["complete"] = val.rules.length == Object.keys(this.validationResults[val._id]).length - 8

                    if(this.validationResults[val._id]["complete"]){
                        const allRes = []
                        let errrF = []
                        Object.keys(this.validationResults[val._id]).forEach(k =>{
                            if(!['complete', 'valid', 'errorMessage', 'fieldsWithError', 'requiredFields', 'current','results', '_id'].includes(k)){
                                allRes.push(this.validationResults[val._id][k].isValid)
                                if(!this.validationResults[val._id][k].isValid){
                                    errrF.push(this.validationResults[val._id][k].fid)
                                }
                            }
                        })
                        this.validationResults[val._id]['fieldsWithError'] = errrF
                        this.validationResults[val._id].valid = allRes.every(el => el)
                        this.validationResults[val._id].current = allRes.includes(true)
                        this.validationResults[val._id].results = [...allRes]

                        let res = this.validationResults[val._id]
                        if(res.valid){
                            this.showErrorMessageForFields(res.requiredFields, res.errorMessage, regIndex)
                        } 
                        
                    }

                })

                // console.log(this.validationResults);
            }
        },
        showErrorMessageForFields(fieldIds, message, regIndex = 0){
            this.activeErrorFields = [...fieldIds]
            this.activeErrorFieldMessages.push(message)
            fieldIds.forEach((id, i) =>{
                this.$refs[`field-${regIndex}-${id}`][0].innerText = message
                this.$refs[`field-${regIndex}-${id}`][0].style.display = "block"
            })
        },
        hideErrorMessage(fieldId, regIndex = 0){
            this.$refs[`field-${regIndex}-${fieldId}`][0].style.display = "none"
        },
        getFields: async function() {
            try {
                const response = await this.$store.dispatch('getAll', {
                    path: 'fields',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId,
                        }
                    }
                })
                this.totalDuplicateFields = response.data.fields.filter(field => field.enableFieldForDuplicateCheck).length
            } catch (e) {
                console.log('erorr getting fields')
            }
        },
        getRegistrant: async function () {//console.log('@@getRegistrant')
            this.gettingRegistration = true
            try {
                const route = this.adminEdit ? `/api/registrations/${this.$route.params.id}` : `/api/registrations/with-code/${this.$route.params.code}`
                const response = await http.get(`${route}?withChildregistrations=true`)
                const typeId = response.data.registration.type._id
                this.registrationTypeId = typeId
                await this.fetchValidations(this.$route.params.eventId, typeId)

                if(response.data.registration.asofdate){
                    this.asofdate = response.data.registration.asofdate
                }else{
                    this.asofdate = response.data.registration.createdAt
                }

                if(response.data && response.data.registration && !this.adminEdit){
                    this.registrantEdit = true;
                    this.registrationId = response.data.registration._id
                    const res = await this.$store.dispatch('getUploadedFilesForRegistration', response.data.registration._id)
                    this.uploadedFiles = res.data.uploads
                    
                }else{
                    this.registrationId = this.$route.params.id
                    const res = await this.$store.dispatch('getUploadedFilesForRegistration', this.registrationId)
                    this.uploadedFiles = res.data.uploads
                }
                

                
                // (response.data.registration && !this.adminEdit) ? this.registrantEdit = true : this.registrantEdit = false
                // console.log('@@this.registrantEdit', this.registrantEdit)

                // Set LocalStorage data on Registration Update
                let _regPreId = response.data.registration._id;
                this.primaryRegistrationID = _regPreId
                let _paymentDetails = await http.post(`/api/payments-attendees`, {registrationId: _regPreId})
                let _preRegDetails = _paymentDetails.data.resObject
                localStorage.eventCodedPreRegValues = JSON.stringify(_preRegDetails)
                const registration = {
                    registrationIndex: 0,
                    ...response.data.registration,
                    totals: {},
                }
                this.primaryRegDate = registration.createdAt;

                let new_fields = []
                registration.type.fields.map((e, i)=>{
                    if(registration.fields[i]==undefined){
                        e.showField = true;
                        new_fields.push(e)
                    }
                })
                registration.fields = registration.fields.concat(new_fields);
                this.registrations = [registration]
                
                this.registrations.map(registration=>{
                    registration.fields = registration.fields.map(field=>{
                        try {
                            let typeField = registration.type.fields.find( ({ _id }) => _id === field._id )
                            typeField.value = field.value
                            typeField.showField = field.showField
                            field = {...typeField}
                        } catch (_error) {}
                        return field
                    })
                    //console.log('@@registration', registration.fields, registration.type.fields)
                })
                

                this.previousTotal = registration.total
                this.payment = {
                    ...this.payment,
                    paymentMethod: registration.paymentMethod,
                    paymentType: registration.paymentType,
                    total: registration.total,
                    depositAmount: registration.depositAmount
                }

                // add child registrations
                this.registrations.push(...response.data.childRegistrations.map((registration, index) => {
                    let _regIndex = index + 1;
                    registration.fields = registration.fields.map(field=>{
                        let typeField = registration.type.fields.find( ({ _id }) => _id === field._id )
                        typeField.value = field.value
                        typeField.showField = field.showField
                        field = {...typeField}
                        return field
                    })
                    return {
                        registrationIndex: _regIndex,
                        ...registration,
                        totals: {},
                    }
                }))
                for(let _reg of this.registrations){
                  _reg.asofdate = null
                  for(let _activities of _reg.registeredActivities) {
                    let _activityDiscount = {}
                    let _activityFee = isNaN(parseInt(_activities.fee)) ? 0 : parseInt(_activities.fee);
                    if(!isNaN(parseInt(_activities.typeBasedFee[_reg.type._id]))) {
                      _activityFee = parseInt(_activities.typeBasedFee[_reg.type._id])
                    }
                    _activityDiscount.discountPrice = 0
                    _activityDiscount.activityFee = _activityFee;
                    _activityDiscount.discountFee = _activityFee - _activityDiscount.discountPrice
                    _activities._formatedDiscount = _activityDiscount
                  }
                  for(let _activities of _reg.fieldBasedActivities) {
                    let _activityDiscount = {}
                    let _activityFee = isNaN(parseInt(_activities.fee)) ? 0 : parseInt(_activities.fee);
                    if(!isNaN(parseInt(_activities.typeBasedFee[_reg.type._id]))) {
                      _activityFee = parseInt(_activities.typeBasedFee[_reg.type._id])
                    }
                    _activityDiscount.discountPrice = 0
                    _activityDiscount.activityFee = _activityFee;
                    _activityDiscount.discountFee = _activityFee - _activityDiscount.discountPrice
                    _activities._formatedDiscount = _activityDiscount
                  }
                }
                this.registrations.forEach( (registration) => {
                    this.calculateTotal(registration)
                })

                this.getRegistrationType()

                //manual discount total
                this.manaualDiscoutns = response.data.paymentDeatils.filter( discount => discount.type==="discount" ).reduce((allManualDiscount, discount) => allManualDiscount + discount.amount, 0)
                this.manaualCharges = response.data.paymentDeatils.filter( charge => (charge.type==="charge" && charge.method==="manual" ) ).reduce((allManualCharge, charge) => allManualCharge + charge.amount, 0)
                //need to save once for sync data client to server
                setTimeout(()=>{
                    if((response.data.registration.total) != this.payment.priceAfterDiscount)
                        this.needTosave = true;
                }, 3000)
                this.minimum_amount_to_pay == undefined && this.event.depositAmount > 0 ? this.minimum_amount_to_pay = this.event.depositAmount : this.minimum_amount_to_pay
                this.custom_payment_amt = this.minimum_amount_to_pay = (this.minimum_amount_to_pay-response.data.registration.paid > 0) ? this.minimum_amount_to_pay-response.data.registration.paid : 0
                //console.log('@@this.registrations', this.registrations)
            } catch (e) {
                console.log('error getting registration', e)
                this.$store.dispatch('handleErrors', e)

                if (e.response.data && e.response.data.error === 'expired-registration-code') {
                    this.$router.push({ name: 'website' })
                }
            }
            this.gettingRegistration = false

            setTimeout(() =>{
                this.runEnhancedValidations()
            }, 2000)
        },
        getRegistrationType: async function () {
            try {
                const response = await http.get(`/api/types/${this.registrations[0].type._id}`)
                this.registrationType = response.data.type
                //order on priority
                if(this.registrationType.orderGroup){
                    let orderGroup = this.registrationType.orderGroup
                    let keysSorted = Object.keys(orderGroup).sort(function(a,b){return orderGroup[a]-orderGroup[b]})
                    let sortedGroup = []
                    keysSorted.map(item=>{
                        let group = this.registrationType.groups.filter(group=>group._id==item)
                        if(group && group[0])
                            sortedGroup.push(group[0])
                        //sortedGroup.push(this.registrationType.groups.filter(group=>group._id==item)[0])
                    })
                    this.registrationType.groups = sortedGroup
                }
                // remove added count from registrationTypes
                this.registrationType.groups.forEach((group, i) => {
                    this.registrations.forEach((registration, index) => {
                        if (index === 0) {
                            return
                        }

                        if (registration.type._id === group._id) {
                            this.registrationType.groupCount[group._id]--
                        }
                    })
                })

            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting registration type during edit registration')
            }
        },
        addRegistration: async function (type) {
            // Settingup the localstorage values
            let _apiAllDiscount = await http.post(`/api/discount-all-set`, {data:{type: type._id}} )
            let _newLocalStorageData = {}
            if(localStorage.eventCodedNewRegValues && localStorage.eventCodedNewRegValues != undefined) {
                let localStoreData = await JSON.parse(localStorage.eventCodedNewRegValues);
                _newLocalStorageData = Object.assign(_newLocalStorageData, localStoreData)
            }
            _newLocalStorageData[type._id] = await _apiAllDiscount.data
            localStorage.eventCodedNewRegValues = await JSON.stringify(_newLocalStorageData)
            // End Settingup the localstorage values

            // Creating Registration Object
            let registration = {
                registrationIndex: this.registrations.length,
                is_new: true,
                eventId: this.$route.params.eventId,
                type,
                email: '',
                firstName: '',
                lastName: '',
                fields: [],
                total: 0,
                grecaptcha: '',
                registeredActivities: [],
                fieldBasedActivities: [],
                applicableActivitesDiscount: [],
                totals: {},
                asofdate: null,
                _discountAmount: 0
            }

            // Adding
            registration.type.fields.forEach(async field => {
                let value = ''
                let showField = true

                if (field.type === 'checkboxes' ||
                    (field.type === 'list' && field.multiple)) {
                        value = []
                        // set default values
                        if (field.defaultValue && field.defaultValue.length) {
                            value = field.defaultValue.split('\n')
                        }
                } else {
                    // set default value
                    if (field.defaultValue && field.defaultValue.length) {
                        value = field.defaultValue
                    }
                }

                if (field.dependsOnFields && field.dependsOnFields.length) {
                    showField = false
                }

                registration.fields.push({
                    ...field,
                    value,
                    showField,
                })
            })

            if (this.registrationType.groupCount && this.registrationType.groupCount[type._id]) {
                this.registrationType.groupCount[type._id]--
            }
            //order on priority
            if(this.registrationType.orderGroup){
                let orderGroup = this.registrationType.orderGroup
                let keysSorted = Object.keys(orderGroup).sort(function(a,b){return orderGroup[a]-orderGroup[b]})
                let sortedGroup = []
                let group = ''
                keysSorted.map(item=>{
                    group = this.registrationType.groups.filter(group=>group._id==item)
                    if(group && group[0])
                        sortedGroup.push(group[0])
                })
                this.registrationType.groups = sortedGroup
            }
            // auto enroll activities
            let applicableActivitesDiscount = []
            for(let activity of this.activities) {
                if (activity.autoEnrollTypes.includes(registration.type._id)) {
                  let _activityDiscount = {}
                  let _activityFee = isNaN(parseInt(activity.fee)) ? 0 : parseInt(activity.fee);
                  if(!isNaN(parseInt(activity.typeBasedFee[registration.type._id]))) {
                    _activityFee = parseInt(activity.typeBasedFee[registration.type._id])
                  }
                  _activityDiscount.discountPrice = 0
                  _activityDiscount.activityFee = _activityFee;
                  _activityDiscount.discountFee = _activityFee - _activityDiscount.discountPrice
                  activity._formatedDiscount = _activityDiscount
                  registration.registeredActivities.push(activity)
                }
            }
            registration.applicableActivitesDiscount = applicableActivitesDiscount
            this.registrations.push(registration)
            this.calculateTotal(registration)
            // console.log('@@this.registrations2', this.registrations)
        },
        submit: async function () {
            if(this.updatingType && !this.validateSecondaryReg()){
                this.$notify({ type: 'danger', message: 'Make sure all the secondary registrations are valid after type change' })
                    return
            }
            if ( this.event.onlinePaymentOnly && this.event.depositAmount>this.payment.priceAfterDiscount ) {
                this.paymentAmountChose = 'fullAmount'
            }
            
            if (this.event.allowDeposit && this.event.onlinePaymentOnly && this.paymentAmountChose=='custom') {
                if(this.custom_payment_amt<this.minimum_amount_to_pay) {
                    this.$notify({ type: 'danger', message: 'Custom Amount should be greater than or equal to to the required minimum amount.' })
                    return
                }
            }
            if (this.websiteNewRegistrationForm) {
                this.$notify({ type: 'danger', message: `Sorry, Registration has been closed for ${this.event.name}` })
                    return
            }
            if ((this.payment.total < this.previousTotal) && !this.adminEdit) {
                this.$notify({ type: 'danger', message: `The New 'Net Total Amount' cannot be lesser that the current 'Net Total Amount'` })
                    return
            }

            if(this.activeErrorFieldMessages.length){
                this.activeErrorFieldMessages.forEach(message => {
                    this.$notify({ type: 'danger', message })
                })
                return
            }

            // check if required fields are filled
            // const requriedFieldErrors = []
            // if (!this.adminAdd && !this.adminEdit) {
            //     this.registrations.forEach((registration, index) => {
            //         registration.fields.forEach(field => {
            //             if (field.required && !(field.value || field.value.length) && field.showField && field.type!=="checkboxes") {
            //                 requriedFieldErrors.push(`${field.title} is required on ${index === 0 ? 'Primary Registrant!' : 'Registrant #' + (index+1)}`)
            //             }
            //             if (field.required && !field.value.length && field.showField && field.type=="checkboxes") {
            //                 requriedFieldErrors.push(`${field.title} is required on ${index === 0 ? 'Primary Registrant!' : 'Registrant #' + (index+1)}`)
            //             }
            //         })
            //     })
            // }
            const requriedFieldErrors = []
            let duplicateFieldsChecking = []
            this.registrations.forEach((registration, index) => {
                let duplicateFieldsInRegistrant = []
                registration.fields.forEach(field => {
                    if (field.enableFieldForDuplicateCheck && this.event.checkForDuplicates)
                        duplicateFieldsInRegistrant.push(field)
                    
                    if (!this.adminAdd && !this.adminEdit) {
                        if (field.required && !(field.value || field.value.length) && field.showField && field.type!=="checkboxes") {
                            requriedFieldErrors.push(`${field.title} is required on ${index === 0 ? 'Primary Registrant!' : 'Registrant #' + (index+1)}`)
                        }
                        if (field.required && !field.value.length && field.showField && field.type=="checkboxes") {
                            requriedFieldErrors.push(`${field.title} is required on ${index === 0 ? 'Primary Registrant!' : 'Registrant #' + (index+1)}`)
                        }
                    }
                })
                let _id = registration._id
                if (this.totalDuplicateFields === duplicateFieldsInRegistrant.length && this.totalDuplicateFields)
                    duplicateFieldsChecking.push({_id, fields: duplicateFieldsInRegistrant})
            })

            if (requriedFieldErrors && requriedFieldErrors.length) {
                let delay = 50
                requriedFieldErrors.forEach(message => {
                    setTimeout(() => {
                        this.$notify({ type: 'danger', message })
                    }, delay)
                    delay += 50
                })

                return
            }

            //  duplicate checking start
            let validation = await http.post(`/api/registrations-validationCheck`, {
                eventId: this.event._id,
                fieldsArr: duplicateFieldsChecking
            })
            validation.data.map((item, index) => {
                if (item) {
                    let errorMsg = duplicateFieldsChecking[index].fields.map(field => field.value )
                    this.$notify({type: 'danger', message: `Duplicate Registration found for ${errorMsg.join(',')}.Unable to create/update registration. Please correct and Try again.` })
                }
            })
            // console.log("VALIDATION", validation)
            let isDUplicate 
            if(validation.data.length)
            isDUplicate = validation.data.reduce((item,tottal)=> item + tottal )
            if (isDUplicate)
                return
            //duplicate checking end

            if (!this.adminAdd && !this.adminEdit && !this.agreed) {
                this.$notify({ type: 'danger', message: 'Please agree to terms and conditions to proceed!' })
                return
            }            

             // if not select any payment methods
             if (this.event.allowDeposit && this.event.onlinePaymentOnly && !this.paymentAmountChose && !this.adminEdit) {
                this.$notify({ type: 'danger', message: 'Please select a payment amount!' })
                return
            }
            // edit registration
            if (this.editRegistration && !this.updatingType) {
                if(!this.userIsAllowedToEdit){
                    this.$notify({
                        type: 'danger',
                        message: 'you are not allowed to edit this registration'
                    })
                    return;
                }
                this.saving = true
                try {
                    await Promise.all(this.registrations.map((registration, index) => {
                        let data = {
                            asofdate: this.asofdate,
                            _registrantEdit: this.registrantEdit,
                            ...registration,
                            status: this.registrations[0].status
                        }

                        // if main registration add updated payment information
                        if (index === 0) {
                            data = {
                                ...data,
                                ...this.payment,
                                asofdate: this.asofdate,
                                primaryRegistrantTotal: registration.total,
                                creator: this.user,
                            }
                        }

                        // save if editing existing registration
                        if (registration._id) {
                            if(this.registrantEdit){
                                for(let i=0; i<this.removedList.length; i++){
                                    this.$store.dispatch('updateWithCode', {...this.removedList[i]} )
                                }
                                this.$store.dispatch('updateWithCode', {
                                    path: 'registrations-code',
                                    id: registration._id,
                                    code: this.$route.params.code,
                                    data
                                })
                                // let updateStatus = http.put(`/api/registrations-code/${registration._id}/${this.$route.params.code}`, data)
                                // console.log('@@updateStatus', updateStatus)
                                // this.$store.dispatch('handleErrors', updateStatus)
                            }else{
                                this.$store.dispatch('update', {
                                    path: 'registrations',
                                    id: registration._id,
                                    data
                                })
                            }

                            // update the files too
                            return this.$store.dispatch('updateRegistrationFile', registration._id)
                        }
                        // create if new child registration
                        else {
                            data.parent = this.registrations[0]._id
                            data.parentConfirmationNumber = this.registrations[0].confirmationNumber
                            data.grecaptcha = this.payment.grecaptcha
                            data.paymentType = 'none'
                            data.asofdate = this.asofdate
                            data.creator = this.user
                            this.$store.dispatch('create', {
                                path: 'registrations',
                                data,
                            })
                            //console.log('@@Create1', data)
                        }
                    }))
                    this.$notify('Information successfully updated!')

                    if (this.registrations[0] && !this.adminEdit) {
                        const mainRegistration = this.registrations[0]

                        //if (this.payment.paymentMethod === 'online') {
                        if (this.event.onlinePaymentOnly) {    
                            if(this.paymentAmountChose=='minimum')
                                this.payment_amount =  this.minimum_amount_to_pay //this.event.depositAmount>this.payment.priceAfterDiscount?this.payment.priceAfterDiscount:this.event.depositAmount
                            if(this.paymentAmountChose=='fullAmount')
                                this.payment_amount = parseFloat(this.payment.priceAfterDiscount - mainRegistration.paid).toFixed(2)
                            if(this.paymentAmountChose=='custom')
                                this.payment_amount = this.custom_payment_amt

                                await this.setCheckoutPageAmount({ amount: this.payment_amount, registrationId: mainRegistration._id })

                            this.$router.push({ name: 'checkout', params: { registrationId: mainRegistration._id }, query: { payment_amount:this.payment_amount } })
                        } else {
                            this.$router.push({ name: 'welcome-email', params: { registrationId: mainRegistration._id } })
                        }
                    }
                    if(this.adminEdit){
                        this.$router.push({ name: 'welcome-email', params: { registrationId: this.registrations[0]._id } })
                    }
                } catch (e) {
                    this.saving = false
                    console.log(e)
                    this.$refs.recaptcha.reset()
                    console.log('error updating registration')
                }
                this.saving = false
            } else {
                // submit new registration
                this.saving = true
                try {
                    // this.registrations.map(reg=>{
                    //     var o = Object.assign({}, reg);
                    //     o.asofdate = this.asofdate;
                    //     o.updatingType = this.updatingType;
                    //     return o;
                    // })
                    let childRegistrations = [...this.registrations]
                    childRegistrations.splice(0, 1)
                    this.payment.paymentMethod = this.event.onlinePaymentOnly ? 'online' : this.payment.paymentMethod
                    // this.registrations[0].total = this.registrations
                    const { data: mainRegistration } = await this.$store.dispatch('create', {
                        path: 'registrations',
                        data: {
                            ...this.payment,
                            ...this.registrations[0],
                            primaryRegistrantTotal: this.registrations[0].total,
                            total : this.registrations.map(registration => registration.total).reduce((total, value) => total + value),
                            childRegistrantNames: childRegistrations.map(registration => {
                                let firstName = registration.fields.find(field => field.fieldMapping === 'firstName')
                                firstName = firstName ? firstName.value : ''

                                let lastName = registration.fields.find(field => field.fieldMapping === 'lastName')
                                lastName = lastName ? lastName.value : ''

                                return firstName + ' ' + lastName
                            }),
                            childRegistrantActivities: childRegistrations.map(registration => {
                                return [...registration.fieldBasedActivities, ...registration.registeredActivities].map(acivity=>acivity.name )
                            }),
                            isAdmin: this.adminAdd,
                            creator: this.user,
                            status: this.event.onlinePaymentOnly ? 'pending' : 'confirmed',
                            host:`${window.location.protocol}//${window.location.host}`,
                            updatingType: this.updatingType
                        },
                    })

                    // the code for uploading files
                    try {
                        await this.$store.dispatch('uploadRegistrationFiles', mainRegistration.registration._id)
                    } catch (error) {
                        console.log(error);                        
                    }
                    

                    if (childRegistrations.length) {
                        await Promise.all(childRegistrations.map(registration => {
                            registration.updatingType = this.updatingType
                            registration.parent = mainRegistration.registration
                            registration.grecaptcha = this.payment.grecaptcha
                            registration.paymentType = 'none'
                            registration.creator = this.user
                            registration.status = mainRegistration.registration.status
                            return this.$store.dispatch('create', { path: 'registrations', data: registration })
                        }))
                    }
                    if (!this.event.onlinePaymentOnly) { 
                        this.$notify('Successfully registered!')
                    }
                    if(this.updatingType){
                        await http.post('/api/registrations/handle-post-type-change', {
                            oldRegId: this.oldPrimaryRegForTypeChange._id, 
                            newRegId: mainRegistration.registration._id
                        })
                    }
                    //if (this.payment.paymentMethod === 'online') {
                    if (this.event.onlinePaymentOnly && !this.updatingType) { 
                        if(this.paymentAmountChose=='minimum')
                            this.payment_amount = this.event.depositAmount>this.payment.priceAfterDiscount?this.payment.priceAfterDiscount:this.event.depositAmount
                        if(this.paymentAmountChose=='fullAmount')
                            this.payment_amount = this.payment.priceAfterDiscount    
                        if(this.paymentAmountChose=='custom')
                            this.payment_amount = this.custom_payment_amt

                        await this.setCheckoutPageAmount({ amount: this.payment_amount, registrationId: mainRegistration.registration._id })
            
                        this.$router.push({ name: 'checkout', params: { registrationId: mainRegistration.registration._id } })
                    } else {
                        this.$router.push({ name: 'welcome-email', params: { registrationId: mainRegistration.registration._id } })
                    }

                    if(!this.adminAdd){
                        http.post(`/api/registrations/${this.registration._id}/resend-confirmation-email?host=${window.location.protocol}//${window.location.host}`)
                    }
                } catch (e) {
                    this.saving = false
                    this.$refs.recaptcha.reset()
                    console.log('error creating new registration', e)
                }
                this.saving = false
            }
            this.needTosave = false;
        },

        calculateTotal: async function (registration) {//console.log('calculateTotal', registration)

            // Fetch discount values from the server
            let _newLocalStorageData = {}
            let _apiAllDiscount = await http.post(`/api/discount-all-set`, {data:{type: registration.type._id}} )
            _newLocalStorageData[registration.type._id] = await _apiAllDiscount.data
            let _localNewRegDiscount = _newLocalStorageData[registration.type._id]
            let priceDetails = {}
            
            // Retriving Local stroage discount values
            let _localPreRegDiscount = null
            if(localStorage.eventCodedPreRegValues && localStorage.eventCodedPreRegValues != undefined) {
                _localPreRegDiscount = await JSON.parse(localStorage.eventCodedPreRegValues)
            }
            // End Retriving Local stroage discount values

            let _this = this
            registration.total = await parseInt(registration.type.price);
            registration.totals = {}

            //Discount Logic for Registration Type Fees __________________________________________________________________________________
            let _registrationDiscount = 0

            if(Object.keys(registration).includes("_id")) { // This block are used for edit already register record
                if(_newLocalStorageData && Object.keys(_newLocalStorageData).includes(registration.type._id)) {
                    let _dict = _newLocalStorageData[registration.type._id]
                    if(Object.keys(_dict).includes("registrationTypeDiscount") && _dict.registrationTypeDiscount.length > 0) {
                        if(_dict.registrationTypeDiscount[0].discountPeriod) {
                            let _todayDate = await this.asofdate? new Date(this.asofdate): new Date();
                            let _startDate = new Date(_dict.registrationTypeDiscount[0].discountStartDate);
                            let _endDate = new Date(_dict.registrationTypeDiscount[0].discountEndDate);
                            if(_todayDate > _startDate && _todayDate < _endDate) {

                                if(_dict.registrationTypeDiscount[0].discountType == "percent") {
                                    _registrationDiscount = parseFloat((_dict.registrationTypeDiscount[0].discountValue * registration.total) / 100);
                                } else {
                                    _registrationDiscount = _dict.registrationTypeDiscount[0].discountValue
                                }
                            }
                        }
                        else{
                            if(_dict.registrationTypeDiscount[0].discountType == "percent") {
                                _registrationDiscount = parseFloat((_dict.registrationTypeDiscount[0].discountValue * registration.total) / 100);
                            } else {
                                _registrationDiscount = _dict.registrationTypeDiscount[0].discountValue
                            }
                        }
                    }
                    //console.log("Pre Reg Data: ", _localPreRegDiscount[registration._id])
                }
            }else{ // This block are used for new register record
                if(_localNewRegDiscount && _localNewRegDiscount.registrationTypeDiscount) {
                    let _breakRegTypeDiscountLoop = false;
                    for(let _regTypeDiscount of _localNewRegDiscount.registrationTypeDiscount) {
                        if(!_breakRegTypeDiscountLoop) { // Checking Discount is an period or not
                            let _discountValue = await parseFloat(_regTypeDiscount.discountValue)
                            if(_regTypeDiscount.discountPeriod) {
                                let _todayDate = await this.asofdate? new Date(this.asofdate): new Date();
                                let _startDate = await new Date(_regTypeDiscount.discountStartDate);
                                let _endDate = await new Date(_regTypeDiscount.discountEndDate);
                                if(_todayDate > _startDate && _todayDate < _endDate) {

                                    registration.registrationTypeDiscount = _regTypeDiscount

                                    if(_regTypeDiscount.discountType == "percent") {
                                        _registrationDiscount = await parseFloat((_discountValue * registration.total) / 100);
                                        _breakRegTypeDiscountLoop = true
                                    } else {
                                        _registrationDiscount = _discountValue
                                        _breakRegTypeDiscountLoop = true
                                    }
                                }
                            } else {

                                registration.registrationTypeDiscount = _regTypeDiscount

                                if(_regTypeDiscount.discountType == "percent") {
                                    _registrationDiscount = await parseFloat((_discountValue * registration.total) / 100);
                                    _breakRegTypeDiscountLoop = true
                                } else {
                                    _registrationDiscount = _discountValue
                                    _breakRegTypeDiscountLoop = true
                                }
                            }
                        }
                    }
                }
            }
            registration._discountAmount = _registrationDiscount

            //Discount Logic for Registration Fields __________________________________________________________________________
            let _regFieldDiscounts = []
            let _registrationFields = [...registration.fields]

            for(let field of _registrationFields){
                if (field.feeField) {
                    field._discountAmount = 0
                    if (field.type === 'list' || field.type === 'radio') {
                        let _fieldValues = field.values.split('\n').filter(function (el) {return el != null && el != "";});
                        const valueIndex = _fieldValues.indexOf(field.value)
                        if (valueIndex !== -1) {
                            let fieldTotal = parseInt(field.feeValues.split('\n')[valueIndex])
                            let operands = field.feeFormula.match(/\[.*?\]/g)

                            // if there is fee formula calculate based on that
                            if (field.feeFormula && operands.length) {
                               let newOperands = operands.map(operand => {
                                   let newOperand
                                   if (operand.toLowerCase().includes('count')) {
                                       newOperand = registration.fields.find(field => field.name === operand.replace(/_count/ig, '').slice(1, -1))

                                        if (newOperand) {
                                            newOperand = newOperand.value.length
                                        }
                                   } else {
                                       newOperand = registration.fields.find(field => field.name === operand.slice(1, -1))

                                       if (newOperand) {
                                           if (newOperand.feeField && newOperand.feeValues && newOperand.feeValues.length) {
                                               newOperand = parseInt(newOperand.feeValues.split('\n')[newOperand.values.split('\n').indexOf(newOperand.value)])
                                           } else {
                                               newOperand = parseInt(newOperand.value)
                                           }
                                       }
                                   }
                                   return newOperand
                               })

                               if (!newOperands.includes(NaN) && !newOperands.includes(undefined)) {
                                   let newFormula = field.feeFormula
                                   operands.forEach((operand, index) => { newFormula = newFormula.replace(operand, newOperands[index]) })
                                   fieldTotal = eval(newFormula)
                                   field.formulaValue = fieldTotal
                               }
                            }

                            //Custom-field discount
                            // if(Object.keys(registration).includes("_id")) { // This block are used for edit already register record
                            //     let _discountAmount = 0;
                            //     if(_localPreRegDiscount && Object.keys(_localPreRegDiscount).includes(registration._id)) {
                            //         let _dict = _localPreRegDiscount[registration._id]
                            //         console.log('cacl')
                            //         console.log(_dict)
                            //         if(Object.keys(_dict).includes("fieldDiscount")) {
                            //             let _getFieldDiscount = _dict.fieldDiscount.find(x=>x.field == field._id)
                            //             if(_getFieldDiscount !== undefined && Object.keys(_getFieldDiscount).length > 0) {
                            //                 _discountAmount = _getFieldDiscount.amount
                            //             }
                            //         }
                            //     }
                            //     field.fieldDiscount = {}
                            //     field._discountAmount = _discountAmount
                            // } else 
                            { // This block are used for new register record
                                field.fieldDiscount = {}
                                let discounts = []
                                let _isFieldFound = true
                                let _regTypeFieldDiscount = _localNewRegDiscount ? _localNewRegDiscount.registrationTypeFieldDiscount : null
                                let _regCustFieldDiscount = _localNewRegDiscount ? _localNewRegDiscount.customFieldDiscount : null
                                // Checking field discount in Custom Field Discount
                                if( _localNewRegDiscount && _regCustFieldDiscount && _regCustFieldDiscount.length > 0) {
                                    discounts = await _regCustFieldDiscount.filter(x=>x.field == field._id)
                                    if(discounts == undefined || discounts.length == 0) {
                                        _isFieldFound = false
                                        discounts = []
                                    }
                                }
                                // Checking field discount in Registration Type Field Discount
                                if(_localNewRegDiscount && _regTypeFieldDiscount && _regTypeFieldDiscount.length > 0) {
                                    discounts = await _regTypeFieldDiscount.filter(x=>x.field == field._id && x.type == registration.type._id)
                                    if(discounts == undefined || discounts.length == 0) {
                                        _isFieldFound = false
                                        discounts = []
                                    }
                                }
                                // available date checking
                                if(discounts.length>0 && discounts[0].discountPeriod==true){
                                    let _todayDate = await this.asofdate? new Date(this.asofdate): new Date();
                                    for(let discount of discounts){
                                        if(_todayDate > new Date(discount.discountStartDate) && _todayDate < new Date(discount.discountEndDate)) {
                                            field.fieldDiscount = discount
                                        }
                                    }
                                }
                                if(discounts.length>0 && discounts[0].discountPeriod==false){
                                    field.fieldDiscount = discounts[0]
                                }
                                // Appling Discount
                                //field.fieldDiscount = discount
                                let _discountAmount = 0;

                                if(Object.keys(field.fieldDiscount).length > 0 && field.fieldDiscount.discountValue) {
                                    let discountFormula = field.fieldDiscount.discountValue.split('\n')[valueIndex]
                                    let discountOperands = discountFormula ? discountFormula.match(/\[.*?\]/g)[0] : "[]"
                                    let newDiscountOperand = null
                                    if ( discountOperands.toLowerCase().includes('count')) {
                                        newDiscountOperand = registration.fields.find(field => field.name === discountOperands.replace(/_count/ig, '').slice(1, -1))
                                        if (newDiscountOperand) {
                                            newDiscountOperand = newDiscountOperand.value.length
                                        }
                                    }else{
                                        newDiscountOperand = 1;
                                    }

                                    if(field.fieldDiscount.discountType=="amount"){
                                        _discountAmount = parseInt(field.fieldDiscount.discountValue.split('\n')[valueIndex])
                                        _discountAmount *= newDiscountOperand
                                    }else{
                                        _discountAmount = parseInt(field.fieldDiscount.discountValue.split('\n')[valueIndex])
                                        _discountAmount *= newDiscountOperand
                                        _discountAmount = parseInt((fieldTotal/100) * _discountAmount)
                                    }
                                }else{
                                    _discountAmount = 0;
                                }
                                field._discountAmount = _discountAmount
                            }
                            if(fieldTotal){
                                _regFieldDiscounts.push({
                                    fieldId: field._id,
                                    totalFee: fieldTotal,
                                    discount: field._discountAmount
                                })
                            }
                            registration.total += parseInt(fieldTotal)
                            registration.totals[field._id] = fieldTotal
                        }
                    } else if (field.type === 'checkboxes') {
                        field.value.forEach(value => {
                            let valueIndex = field.values.split('\n').indexOf(value)
                            if (valueIndex !== -1) {
                                let fieldTotal = parseInt(field.feeValues.split('\n')[valueIndex])
                                let operands = field.feeFormula.match(/\[.*?\]/g)

                                if (field.feeFormula && operands.length) {
                                    let newOperands = operands.map(operand => {
                                        let newOperand
                                        if (operand.toLowerCase().includes('count')) {
                                            newOperand = registration.fields.find(field => field.name === operand.replace(/_count/ig, '').slice(1, -1))

                                            if (newOperand) {
                                                newOperand = newOperand.value.length
                                            }
                                        } else {
                                            newOperand = registration.fields.find(field => field.name === operand.slice(1, -1))

                                            if (newOperand) {
                                                if (newOperand.feeField && newOperand.feeValues && newOperand.feeValues.length) {
                                                    newOperand = parseInt(newOperand.feeValues.split('\n')[newOperand.values.split('\n').indexOf(newOperand.value)])
                                                } else {
                                                    newOperand = parseInt(newOperand.value)
                                                }
                                            }
                                        }

                                        return newOperand
                                    })

                                    if (!newOperands.includes(NaN)) {
                                        let newFormula = field.feeFormula
                                        operands.forEach((operand, index) => { newFormula = newFormula.replace(operand, newOperands[index]) })
                                        fieldTotal = eval(newFormula)
                                        field.formulaValue = fieldTotal
                                    }
                                }
                                registration.totals[field._id] = fieldTotal
                            }
                        })
                    }
                }
            }
            registration.fields = _registrationFields

            // register activity discount
            let includedActivities = {}
            let _regActivityDiscounts = []
            let _registeredActivities = [...registration.registeredActivities]

            for(let activity of _registeredActivities) {
                includedActivities[activity._id] = true

                activity._discountAmount = 0

                // code added by shyamojjwal@technoexponent, date: 15-11-2019
                let _activityDiscount = 0;
                let _activityFee = isNaN(parseInt(activity.fee)) ? 0 : parseInt(activity.fee);
                if(!isNaN(parseInt(activity.typeBasedFee[registration.type._id]))) {
                    _activityFee = parseInt(activity.typeBasedFee[registration.type._id])
                }
                registration.total += parseInt(_activityFee)

                if(_localPreRegDiscount) {
                    // Here your updated code
                } else {
                    let _isFieldFound = true
                    let _regActivityDiscount = _localNewRegDiscount.registrationTypeActivityDiscount
                    if(
                        _regActivityDiscount instanceof Array == false &&
                        _regActivityDiscount instanceof Object == true &&
                        Object.keys(_regActivityDiscount).includes(activity._id)
                    ) {

                        let _breakRegTypeDiscountLoop = false;
                        for(let _item of _regActivityDiscount[activity._id]) {
                            if(!_breakRegTypeDiscountLoop) { // Checking Discount is an period or not
                                let _discountValue = await parseInt(_item.discountValue)
                                if(_item.discountPeriod) {
                                    let _todayDate = await this.asofdate? new Date(this.asofdate): new Date();
                                    let _startDate = await new Date(_item.discountStartDate);
                                    let _endDate = await new Date(_item.discountEndDate);
                                    if(_todayDate > _startDate && _todayDate < _endDate) {

                                        activity.activityDiscount = _item

                                        if(_item.discountType == "percent") {
                                            _activityDiscount = await parseInt((_discountValue * _activityFee) / 100);
                                            _breakRegTypeDiscountLoop = true
                                        } else {
                                            _activityDiscount = _discountValue
                                            _breakRegTypeDiscountLoop = true
                                        }
                                    }
                                } else {
                                    activity.activityDiscount = _item

                                    if(_item.discountType == "percent") {
                                        _activityDiscount = await parseInt((_discountValue * _activityFee) / 100);
                                        _breakRegTypeDiscountLoop = true
                                    } else {
                                        _activityDiscount = _discountValue
                                        _breakRegTypeDiscountLoop = true
                                    }
                                }
                            }
                        }
                    }
                }

                // Updating activity discount
                activity._discountAmount = _activityDiscount
                _regActivityDiscounts.push({
                    activityId: activity._id,
                    totalFee: _activityFee,
                    discount: _activityDiscount,
                })
            }
            registration.registeredActivities = _registeredActivities
            // end register activity discount-----------------------------------

            registration.fieldBasedActivities = registration.fieldBasedActivities.filter(activity => !includedActivities[activity._id])

            // field base activity discount
            let _fieldBaseActivities = [...registration.fieldBasedActivities]
            registration.fieldBasedActivities = [];
            var _regFieldBasedActivityDiscounts = []
            for(let activity of _fieldBaseActivities){

                let _activityDiscount = 0;

                let _activityFee = isNaN(parseInt(activity.fee)) ? 0 : parseInt(activity.fee);

                if(!isNaN(parseInt(activity.typeBasedFee[registration.type._id]))) {
                _activityFee = parseInt(activity.typeBasedFee[registration.type._id])
                }
                registration.total += parseInt(_activityFee)

                if(_localPreRegDiscount) {
                    // Here your updated code
                } else {
                    let _regActivityDiscount = _localNewRegDiscount.registrationTypeActivityDiscount
                    if(
                        _regActivityDiscount instanceof Array == false &&
                        _regActivityDiscount instanceof Object == true &&
                        Object.keys(_regActivityDiscount).includes(activity._id)
                    ) {

                        let _breakRegTypeDiscountLoop = false;
                        for(let _item of _regActivityDiscount[activity._id]) {
                            if(!_breakRegTypeDiscountLoop) { // Checking Discount is an period or not
                                let _discountValue = await parseInt(_item.discountValue)
                                if(_item.discountPeriod) {
                                    let _todayDate = await this.asofdate? new Date(this.asofdate): new Date();
                                    let _startDate = await new Date(_item.discountStartDate);
                                    let _endDate = await new Date(_item.discountEndDate);
                                    if(_todayDate > _startDate && _todayDate < _endDate) {
                                        activity.activityDiscount = _item
                                        if(_item.discountType == "percent") {
                                            _activityDiscount = await parseInt((_discountValue * _activityFee) / 100);
                                            _breakRegTypeDiscountLoop = true
                                        } else {
                                            _activityDiscount = _discountValue
                                            _breakRegTypeDiscountLoop = true
                                        }
                                    }
                                } else {
                                    activity.activityDiscount = _item
                                    if(_item.discountType == "percent") {
                                        _activityDiscount = await parseInt((_discountValue * _activityFee) / 100);
                                        _breakRegTypeDiscountLoop = true
                                    } else {
                                        _activityDiscount = _discountValue
                                        _breakRegTypeDiscountLoop = true
                                    }
                                }
                            }
                        }
                    }
                }

                activity._discountAmount = _activityDiscount
                _regFieldBasedActivityDiscounts.push({
                    activityId: activity._id,
                    totalFee: _activityFee,
                    discount: _activityDiscount,
                })
            }
            registration.fieldBasedActivities = _fieldBaseActivities
            // end field base activity discount---------------------------------

            this.payment.total = this.registrations.map(registration => registration.total).reduce((total, value) => total + value)

            if (!this.recalculateFees) {
                this.payment.total = this.previousTotal
            }
            // Adding Reg Prices
            // priceDetails.regIndex = registration.registrationIndex
            // priceDetails.regTypeId = registration.type._id
            
            priceDetails.regPrice = isNaN(parseFloat(registration.type.price)) ? 0 : parseFloat(registration.type.price);
            priceDetails.regDiscountPrice = registration._discountAmount
            priceDetails.regFieldDiscounts = _regFieldDiscounts
            priceDetails.regActivityDiscounts = _regActivityDiscounts
            priceDetails.regFieldBasedActivityDiscounts = _regFieldBasedActivityDiscounts

            registration.priceDetails = priceDetails
            // if(this.registrationPriceDetails.findIndex(x=>x.regTypeId == registration.type._id && x.regIndex == registration.registrationIndex) > -1){
            //     let _index = await this.registrationPriceDetails.findIndex(x=>x.regTypeId == registration.type._id && x.regIndex == registration.registrationIndex)
            //     await this.registrationPriceDetails.splice(_index, 1)
            // }
            // await this.registrationPriceDetails.push(priceDetails)
        },
        onRecaptchaVerify: function (grecaptcha) {
            this.payment.grecaptcha = grecaptcha
        },
        removeRegistration: async function (registration, index) {
            const type = this.registrationType.groups.find(t => t._id === registration.type._id)
            if (type && this.registrationType.groupCount && !this.invalidSecondaryRegError) {
                this.registrationType.groupCount[type._id]++
            }
            await this.registrations.splice(index, 1)
            this.registrations.forEach( async (registration, index) => {
                await this.calculateTotal(registration)
            })
            this.validateSecondaryReg();
            // this.payment.total = this.registrations.map(registration => registration.total).reduce((total, value) => total + value)
        },
        deleteRegistrantBySelf: async function (registration, index) {
            //remove from main object
            const type = this.registrationType.groups.find(t => t._id === registration.type._id)
            if (type && this.registrationType.groupCount) {
                this.registrationType.groupCount[type._id]++
            }
            await this.registrations.splice(index, 1)
            this.registrations.forEach( async (registration, index) => {
                await this.calculateTotal(registration)
            })

            //creating array
            delete registration.fields
            registration.status = "deleted"
            registration.creator = this.user

            this.removedList.push({
                path: 'registrations-code',
                data: registration,
                id: registration._id,
                code: this.$route.params.code,
                query: `host=${window.location.protocol}//${window.location.host}`
            })
            // let test = await this.$store.dispatch('updateWithCode', {
            //     path: 'registrations-code',
            //     data: registration,
            //     id: registration._id,
            //     code: this.$route.params.code,
            //     query: `host=${window.location.protocol}//${window.location.host}`
            // })
            // await this.getRegistrant()
            // this.agreed = true
            // setTimeout(()=>{
            //     this.submit()
            // },500)

        },
        onRadioChange: async function (registration, index, field) {//console.log('@@onRadioChange')
            await this.toggleDependantFields(registration)
            await this.addFieldBasedActivities(registration, field)
            // if (this.autoAdjustActivities) {
            //     this.addFieldBasedActivities(registration, field)
            // }
            for(let _reg of this.registrations){
              this.calculateTotal(_reg)
            }

            // await this.calculateTotal(this.registrations[index])
            // this.calculateTotal(registration)
        },
        onListChange: function (registration, field, selectedValue) {//console.log()
            this.toggleDependantFields(registration)
            if (this.autoAdjustActivities) {
                this.addFieldBasedActivities(registration, field)
            }
            for(let _reg of this.registrations){
              this.calculateTotal(_reg)
            }
            // this.calculateTotal(registration)
        },
        onCheckboxChange: async function (registration, index, field, selectedValues) {//console.log('@@onCheckboxChange')

            if(field.sortUsingValuesWhileSaving && this.fieldsWithSorting[field._id]){
                const originalOrder = this.fieldsWithSorting[field._id]
                selectedValues = selectedValues.sort((a,b)=>{
                    return originalOrder.indexOf(a) - originalOrder.indexOf(b)
                })
            }

            await this.toggleDependantFields(registration)
            await this.addFieldBasedActivities(registration, field, selectedValues)
            for(let _reg of this.registrations){
              this.calculateTotal(_reg)
            }

            // await this.calculateTotal(this.registrations[index])
            // await this.calculateTotal(registration)
        },
        toggleDependantFields: function (registration) {//console.log('@@toggleDependantFields')
            let _regFields = [...registration.fields]
            for(let field of _regFields) {
            // registration.fields.forEach(field => {
                if (field.dependsOnFields && field.dependsOnFields.length) {
                    const showField = registration.fields.find(f => {
                        if (f.type === 'checkboxes') {
                            return field.dependsOnFields.includes(f._id) && field.dependsOnValues.find(value => f.value.includes(value))
                        }
                        return field.dependsOnFields.includes(f._id) && field.dependsOnValues.includes(f.value)
                    })
                    if (showField) {
                        field.showField = true
                    } else {
                        field.showField = false
                    }
                }
            // })
            }
            registration.fields = _regFields
        },
        toggleFieldBasedActivities: function (registration, activity, index, conditionsMet) {//console.log('@@toggleFieldBasedActivities', registration, activity, index, conditionsMet)
            // ***** Depreceated in favor of simpler implementation *****

            // console.log(activity);
            // do not continue if activity doesn't have dependance
            if (!activity.dependsOnFields && !activity.dependsOnFields.length) {
                return
            }

            const numberOfConditions = activity.dependsOnFields.filter(field => field !== null).length
            if (numberOfConditions <= index) {
                return
            }

            let conditionMet = false
            const dependantField = activity.dependsOnFields[index]
            const dependantValue = activity.dependsOnValues[index]

            const field = registration.fields.find(field => field._id === dependantField)

            // It can be a possible place for SUNDAY lunch error
            if (field && ((field.type === 'checkboxes' && field.value.includes(dependantValue)) || field.value === dependantValue)) {
              conditionMet = true
            }

            conditionsMet.push(conditionMet)

            if (index < numberOfConditions - 1) {
                this.toggleFieldBasedActivities(registration, activity, index + 1, conditionsMet)
            } else {
                let allConditionsMet = false
                const dependanceType = activity.dependanceType

                if (dependanceType === 'and') {
                    allConditionsMet = conditionsMet.every(condition => condition === true)
                } else {
                    allConditionsMet = conditionsMet.includes(true)
                }

                if (allConditionsMet) {
                  let _activityDiscount = {}
                  let _activityFee = isNaN(parseInt(activity.fee)) ? 0 : parseInt(activity.fee);
                  if(!isNaN(parseInt(activity.typeBasedFee[registration.type._id]))) {
                    _activityFee = parseInt(activity.typeBasedFee[registration.type._id])
                  }
                  _activityDiscount.discountPrice = 0
                  _activityDiscount.activityFee = _activityFee;
                  _activityDiscount.discountFee = _activityFee - _activityDiscount.discountPrice
                  activity._formatedDiscount = _activityDiscount
                  registration.fieldBasedActivities.push(activity)
                }
            }
        },
        addFieldBasedActivities: async function (registration) {//console.log('@@addFieldBasedActivities11')
            registration.fieldBasedActivities = []
            //registration.registeredActivities = []
            //console.log('Test', this.activities);
            if(!this.activities.length){
                await this.$store.dispatch('getAll', {
                    path: 'activities',
                    params: {
                        filters: {
                            eventId: this.$route.params.eventId
                        }
                    }
                })
                // console.log('@@act', response)
            }
            // for(let activity of this.activities) {
            // // this.activities.forEach(activity => {
            //     this.toggleFieldBasedActivities(registration, activity, 0, [])
            // // })
            // }

            let allConditions = {}

            for(let activity of this.activities) {
                const dependantFields = activity.dependsOnFields;
                const dependantValues = activity.dependsOnValues;
                dependantFields.forEach((df, i) =>{
                    if(allConditions[activity._id]){
                        allConditions[activity._id][df] = dependantValues[i]
                    }else{
                        allConditions[activity._id] = {}
                        allConditions[activity._id][df] = dependantValues[i]
                    }
                });
                allConditions[activity._id]["dependanceType"] = activity.dependanceType
                allConditions[activity._id]["activity"] = activity
            }
            registration.fields.forEach(field => {
                Object.values(allConditions).forEach(condition => {
                    let result = false
                    if(condition[field._id]){
                        if(field.type === 'checkboxes' && field.value.includes(condition[field._id])){
                            result = true
                        }else if(field.value === condition[field._id]){
                            result = true                            
                        }
                        if(condition["result"]){
                            condition["result"].push(result)
                        }else{
                            condition["result"] = [ result ]
                        }
                        // For better debugging
                        // if(condition["fields"]){
                        //     condition["fields"].push(field)
                        // }else{
                        //     condition["fields"] = [ field ]
                        // }
                    }
                })
            })
            // console.log(allConditions);
            Object.values(allConditions).forEach(condition => {
                let valid = false;
                if(condition.dependanceType == 'and' && condition.result.every(result => result === true)){
                    valid = true
                }else if(condition.dependanceType != 'and' && condition.result.some(result => result === true)){
                    valid = true
                }
                if(valid){
                    let _activityDiscount = {}
                    let _activityFee = isNaN(parseInt(condition.activity.fee)) ? 0 : parseInt(condition.activity.fee);
                    if(!isNaN(parseInt(condition.activity.typeBasedFee[registration.type._id]))) {
                        _activityFee = parseInt(condition.activity.typeBasedFee[registration.type._id])
                    }
                    _activityDiscount.discountPrice = 0
                    _activityDiscount.activityFee = _activityFee;
                    _activityDiscount.discountFee = _activityFee - _activityDiscount.discountPrice
                    condition.activity._formatedDiscount = _activityDiscount
                    registration.fieldBasedActivities.push(condition.activity)
                }
            })

        },
        handleMediaChange(event, field){
            this.validateFile(event.target.files[0], event)
            if(this.editMode){
                field.value = null
                this.updateFile(event, field)
            }else{
                this.uploadFile(event, field)
            }
        },
        uploadFile: async function (event, field) {
            if (!event.target.files[0]) {
                return
            }

            this.$set(this.uploadingFiles, field._id, { bannerProgress: 1, bannerInterval: null })
            this.$set(this.uploadingFiles[field._id], 'bannerInterval', setInterval(() => {
                if (this.uploadingFiles[field._id].bannerProgress < 98) {
                    this.$set(this.uploadingFiles[field._id], 'bannerProgress', this.uploadingFiles[field._id].bannerProgress + 1)
                } else {
                    clearInterval(this.uploadingFiles[field._id].bannerInterval)
                    this.$set(this.uploadingFiles[field._id], 'bannerInterval', null)
                }
            }, 100))
            const data = {
                fieldId: field._id,
                registationId: null,
                file: event.target.files[0]
            }
            this.$store.commit('PUSH_TO_UPLOADS', data)
            field.value = data.file

            clearInterval(this.uploadingFiles[field._id].bannerInterval)
            this.$set(this.uploadingFiles[field._id], 'bannerInterval', null)
            this.$set(this.uploadingFiles[field._id], 'bannerProgress', 100)
        },
        updateFile: async function (event, field) {
            if (!event.target.files[0]) {
                return
            }
            this.uploadedFiles = this.uploadedFiles.filter(el => el.fieldId != field._id)

            this.$set(this.uploadingFiles, field._id, { bannerProgress: 1, bannerInterval: null })
            this.$set(this.uploadingFiles[field._id], 'bannerInterval', setInterval(() => {
                if (this.uploadingFiles[field._id].bannerProgress < 98) {
                    this.$set(this.uploadingFiles[field._id], 'bannerProgress', this.uploadingFiles[field._id].bannerProgress + 1)
                } else {
                    clearInterval(this.uploadingFiles[field._id].bannerInterval)
                    this.$set(this.uploadingFiles[field._id], 'bannerInterval', null)
                }
            }, 100))

            const data = {
                fieldId: field._id,
                registrationId: this.registrationId,
                file: event.target.files[0]
            }

            this.$store.commit('PUSH_TO_UPDATES', data)
            field.value = data.file

            clearInterval(this.uploadingFiles[field._id].bannerInterval)
            this.$set(this.uploadingFiles[field._id], 'bannerInterval', null)
            this.$set(this.uploadingFiles[field._id], 'bannerProgress', 100)
        },
        download: async function (file) {
            try {
                const response = await http.get(this.baseUrl + file.path, {
                    responseType: 'arraybuffer'
                })
                download(response.data, file.name)
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error downloading list', e)
            }
        },
        validateFile(file, event=null){
            const size = (file.size / (1024*1024)).toFixed(2)
            const allowedMimeTypes = ['image/jpeg','image/png', 'image/svg+xml', 'application/pdf', 'image/gif', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ]
            if(!allowedMimeTypes.includes(file.type)){
                this.$notify({ type: 'danger', message: 'Invalid file type' })
                if(event){
                    event.target.value = null
                }
                return false
            }
            if(size > 2){
                this.$notify({ type: 'danger', message: 'File size should be less than 2 MB' })
                if(event){
                    event.target.value = null
                }
                return false
            }

            return true
        },
        removeFile(field){
            if(this.editMode){
                this.$store.commit('REMOVE_FROM_UPDATES', field._id)
                this.$store.commit('ADD_TO_DELETE_LIST', field._id)
                this.uploadedFiles = this.uploadedFiles.filter(el => el.fieldId != field._id)
            }else{
                this.$store.commit('REMOVE_FROM_UPLOADS', field._id)
            }
            field.value = null
            this.$refs[`field-${field._id}`][0].value = null
        }
    },
    filters: {
        gross: (payment) => {
            let total = payment.total
            return total
        },
    }
};
</script>
<style>
    .textWithBtn {
        display: block;
        width: 100%;
        margin: 22px 0 0;
        text-align: right;
        border: black;
        background: #25a5f5;
        padding: 0 10px 10px;
        border-style: solid;
        border-width: 1px;
    }
    .textWithBtn p {
       display: block;
    font-size: 14px;
    line-height: initial;
    /*font-weight: 600;*/
    margin: 0;
    background-color: #25a5f5;
    padding: 8px 15px;
    text-align: center;
    color: #fff;
    margin: 0 -10px;
    }
    .textWithBtn .btn{
        /*margin: 14px 0 0 0;*/
        background-color: #388E3C !important;
        float:right;
    }
    .textWithBtn .btn:first-child,
    .textWithBtn p:first-child{margin-top: 0;}
    .text-underline{text-decoration: underline;}
    .el-form-item__content .divider{border-bottom: 1px solid #2c2c2c;}
    /**/
    .el-form-item {
        margin-bottom: 22px;
        /* max-width: 80%; */
    }
    .card label {
        font-size: .8571em;
        margin-bottom: 5px;
        color: black !important;   
    }
    .el-checkbox__inner {
        display: inline-block;
        position: relative;
        border: 1px solid black !important;
        border-radius: 2px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        width: 14px;
        height: 14px;
        background-color: #fff;
        z-index: 1;
        -webkit-transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
        transition: border-color .25s cubic-bezier(.71,-.46,.29,1.46),background-color .25s cubic-bezier(.71,-.46,.29,1.46);
    }
    .align-item-checkbox .el-checkbox + .el-checkbox {
    margin-left: 00px;
}
.align-item-checkbox{
    margin:0 -15px !important;
}
.align-item-checkbox .el-checkbox{
    padding:0 15px;
}
    .el-radio__inner {
        border: 1px solid #303133 !important;
        border-radius: 100%;
        width: 14px;
        height: 14px;
        background-color: #fff;
        cursor: pointer;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }
    label {
        font-weight: bold;
    }

.reg-card-header {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    border-bottom: 2px solid #c1bbbb;
    padding-bottom: 10px;
    color: #6d6c6c;
}
.form-field-format .el-form-item{
    flex-wrap: wrap;
    max-width: 100%;
}
.form-field-format label{
   width: 100% !important;
    text-align: left;
}
.form-field-format .el-form-item__content{
    margin: 0 !important;
}
.main-form-container{
    max-width: 990px;
    margin: auto;
    background: #ebeef5;
    padding: 15px;
    margin-bottom: 20px;
    border-color: black;
    border-style: solid;
    border-width: 1px;
}
.form-avtar-image {
    width: 100px;
    height: 100px;
    border-radius: 100%;
    margin: 0;
    border: 1px solid #afacac;
    overflow: hidden;
}
.form-avtar-image img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.profile-name{
   font-weight: 600;
    font-size: 20px;
    max-width: calc(100% - 100px);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.main-form-container .el-form-item .el-form-item__label{
    font-size: 15px;
    margin-bottom: -3px;
    /* color: #9A9A9A !important; */
    color: #343434bd !important;
    font-weight: 600;
    display: block;

}
.main-form-container .el-form-item  .el-input input{
    border-radius:20px;
    border: 1px solid #b7b9bd !important;
}
.main-form-container  .el-form-item__label{
    width:100%;
    text-align: left;
}
.main-form-container  .el-checkbox__inner {
    border-radius: 0;
    width: 18px;
    height: 18px;
}
.main-form-container  .el-textarea__inner{
    border: 1px solid #b7b9bd !important;
}
.main-form-container .el-checkbox, .main-form-container .el-checkbox__input {
    display: inline-flex;
    position: relative;
    white-space: nowrap;
    align-items: center;
    /*flex-wrap: wrap;*/
}
.main-form-container .el-checkbox__inner::after {
    border: 2px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 10px;
    left: 6px;
}
.main-form-container .el-checkbox__inner{
    border-color:#656565 !important;
}
.custom-card-box{
        max-width: 991px;
        display: block !important;
        margin:auto;
        padding:20px;
}
.close-btn{
        font-size: 18px !important;
    width: 20px !important;
    height: 20px !important;
    padding: 0 !important;
    color: #f14343 !important;
}
.profile-image-viewer{
    display:flex;
    align-items: center;
}
.input-payment-amount-select-group{
    text-align: right;
}
.input-payment-amount-select-group .col-3.el-input {
    padding-right: 0;
    width: 124px;
    max-width: 125px;
}

.el-form-item p{
    line-height: initial;
}


html {
    scroll-behavior: smooth;
}

.form-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    max-width: max-content;
    margin: 0 auto;
    gap: 10px;
}
.left-form{
    order: 1;
    margin-left: 200px;
}
.right-amount{
    width: 350px;
    order: 2;
    position: relative;
    top: 0;
    z-index: 100;
}

.amount-card-inner{
    position: sticky;
    top: 10px;
    border-radius: 3px;
    padding: 20px;
    background: rgb(255, 255, 255);
}
.go-to-payment-btn{
    display: block;
    width: 100%;
}



@media only screen and (max-width:1700px){
    .left-form{
        margin: 0;
    }
    
}
@media only screen and (max-width:1600px){
    .form-container{
        flex-direction: column;
    }
    .left-form{
        order: 2;
    }
    .right-amount{
        order: 1;
        width: 100%;
        position: sticky;
        top: 0;
    }
    .go-to-payment-btn{
        display: block;
        width: 100%;
    }
    
}

@media only screen and (max-width:639px){
    .profile-image-viewer{
        display: block;
    }
    .form-avtar-image{
        margin:15px auto;
    }
    .profile-name{
        max-width:100%;
        text-align: center;
    }
    .custom-card-box{
        padding:0;
    }
    .align-item-checkbox .el-checkbox__label{
        white-space: normal;
    }
    .el-form-item p{
        line-height: initial;
    }
    .align-radio-btn{
        margin:0 -15px;
    }
    .align-radio-btn .el-radio+.el-radio {
        margin-left: 0px;
    }
    .align-radio-btn .el-radio{
        padding:0 15px;
    }
}

.err-msg{
    color: red !important;
    display: none;
}
.disabled-select input{
    height: 40px !important;
}


</style>
